<template>
  <v-app>
    <v-main>
      <v-container fluid v-if="isTrue">
        <v-form v-if="!isCalendar">
          <v-row>
            <v-col>
              <v-autocomplete
                :items="modals"
                v-model="selectModal"
                outlined
                item-text="title"
                label="Специализация"
                clearable
                hide-details
                color="primary"
                @change="getMedicinesToModals"
              >
                <template v-slot:selection="data">
                  <v-chip v-bind="data.attrs" :input-value="data.selected">
                    {{ data.item.title }}
                  </v-chip>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col>
              <v-select
                :items="branch"
                v-model="selectBranch"
                outlined
                item-text="LABEL"
                item-value="FM_INTORG_ID"
                label="Филиал"
                multiple
                hide-details
                color="primary"
                clearable
              >
              </v-select>
            </v-col>
            <v-col>
              <v-select
                :items="status"
                v-model="selectStatus"
                outlined
                item-text="TITLE"
                item-value="ID"
                label="Статус"
                hide-details
                color="primary"
                clearable
              >
              </v-select>
            </v-col>
            <v-col>
              <v-autocomplete
                :items="medicines"
                v-model="selectMedicine"
                outlined
                multiple
                item-text="ФИО"
                item-value="Ид"
                label="Врач"
                hide-details
                color="primary"
                placeholder="Начните вводить..."
                no-data-text="Ничего не найдено"
                clearable
              >
                <template v-slot:selection="data">
                  <v-chip
                    v-bind="data.attrs"
                    :input-value="data.selected"
                    close
                    @click="openMedicine(data.item)"
                    @click:close="remove(data.item, 'medicine')"
                  >
                    {{ data.item.ФИО }}
                  </v-chip>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col>
              <v-autocomplete
                v-model="selectedPacient"
                :items="pacients"
                :search-input.sync="searchPacient"
                item-text="name"
                item-value="id"
                label="Пациент"
                outlined
                hide-details
                color="primary"
                clearable
                placeholder="ФИО или телефона"
                no-data-text="Ничего не найдено"
                @update:search-input="onInput"
              >
                <template v-slot:selection="data">
                  <v-chip
                    v-bind="data.attrs"
                    :input-value="data.selected"
                    @click="openPacient(data.item)"
                  >
                    {{ data.item.name }}
                  </v-chip>
                </template>
                <template v-slot:item="{ item }">
                  <div>
                    <strong>{{ item.name }}</strong>
                    <div class="text-caption text--secondary">
                      {{ item.phone }}
                    </div>
                    <div class="text-caption text--secondary">
                      {{ item.birthday }}
                    </div>
                  </div>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-btn
                :disabled="loadingShedule"
                class="ma-2"
                outlined
                color="primary"
                @click="startPolling"
              >
                Показать
              </v-btn>
            </v-col>
            <v-col style="color: #2196f3">
              Время обновления: {{ timeRefresh }}
            </v-col>
          </v-row>
        </v-form>
        <v-dialog
          v-model="medicineItem.modal"
          transition="dialog-top-transition"
          max-width="700"
        >
          <v-card class="rounded-xl">
            <v-toolbar color="grey lighten-1" class="mb-5">
              <v-row class="justify-space-between align-center">
                <v-col cols="auto">
                  <p class="ma-0">
                    {{ medicineItem["ФИО"] }}
                  </p>
                </v-col>
                <v-col cols="auto">
                  <v-btn icon @click="medicineItem.modal = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn></v-col
                >
              </v-row>
            </v-toolbar>
            <v-card-text>
              <template v-if="medicineLoading">
                <div
                  class="d-flex flex-column align-center justify-center py-8"
                >
                  <v-progress-circular
                    indeterminate
                    color="primary"
                    size="48"
                    class="mb-3"
                  />
                  <span class="text-body-2 text--secondary"
                    >Загрузка данных врача...</span
                  >
                </div>
              </template>
              <v-simple-table v-else>
                <thead>
                  <tr>
                    <th></th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Специальность</td>
                    <td>{{ medicineItem.speciality }}</td>
                  </tr>
                  <tr>
                    <td>Значимый опыт работы</td>
                    <td>
                      {{ medicineItem.specExp }}
                    </td>
                  </tr>
                  <tr>
                    <td>Регалии врача</td>
                    <td>{{ medicineItem.regalia }}</td>
                  </tr>
                  <tr>
                    <td>Что лечит</td>
                    <td>
                      {{ medicineItem.whatCures }}
                    </td>
                  </tr>
                  <tr>
                    <td>Рейтинг Продокторова</td>
                    <td>{{ medicineItem.doctorsRating }}</td>
                  </tr>
                  <tr>
                    <td>С какого возраста принимает</td>
                    <td>{{ medicineItem.ageTake }}</td>
                  </tr>
                  <tr>
                    <td>Стаж работы(с)</td>
                    <td>{{ medicineItem.experience }}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-dialog
          v-model="pacientItem.modal"
          transition="dialog-top-transition"
          max-width="700"
        >
          <v-card class="rounded-xl">
            <v-toolbar color="grey lighten-1" class="mb-5">
              <v-row class="justify-space-between align-center">
                <v-col cols="auto">
                  <p class="ma-0">
                    {{ pacientItem.name }}
                  </p>
                </v-col>
                <v-col cols="auto">
                  <v-btn icon @click="pacientItem.modal = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn></v-col
                >
              </v-row>
            </v-toolbar>
            <v-card-text>
              <v-simple-table>
                <thead>
                  <tr>
                    <th></th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Телефон</td>
                    <td>
                      <a :href="`tel:${pacientItem.phone}`">{{
                        pacientItem.phone
                      }}</a>
                    </td>
                  </tr>
                  <tr>
                    <td>Email</td>
                    <td>
                      <a :href="`mailto:${pacientItem.email}`">{{
                        pacientItem.email
                      }}</a>
                    </td>
                  </tr>
                  <tr>
                    <td>День рождения</td>
                    <td>{{ pacientItem.birthday }}</td>
                  </tr>
                  <tr>
                    <td>Город проживания</td>
                    <td>
                      {{ pacientItem.city }}
                    </td>
                  </tr>
                  <tr>
                    <td>Адрес проживания</td>
                    <td>{{ pacientItem.addres }}</td>
                  </tr>
                  <tr>
                    <td>ФИО представителя</td>
                    <td>{{ pacientItem.nameAgent }}</td>
                  </tr>
                  <tr>
                    <td>Телефон представителя</td>
                    <td>
                      <a :href="`tel:${pacientItem.phoneAgent}`">{{
                        pacientItem.phoneAgent
                      }}</a>
                    </td>
                  </tr>
                  <tr>
                    <td>Email представителя</td>
                    <td>
                      <a :href="`mailto:${pacientItem.emailAgent}`">{{
                        pacientItem.emailAgent
                      }}</a>
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-row v-if="loading == true">
          <v-col>
            <v-progress-linear
              color="primary"
              height="6"
              indeterminate
              rounded
            ></v-progress-linear>
          </v-col>
        </v-row>
        <v-row class="fill-height" v-if="isCalendar">
          <v-col cols="12" md="3" class="reserve-sidebar pa-3">
            <v-card outlined class="mb-3">
              <v-card-title
                class="subtitle-1 d-flex flex-wrap align-center justify-space-between"
                style="gap: 8px"
              >
                <span>Резервные записи</span>
                <v-btn
                  small
                  color="primary"
                  outlined
                  @click="openAddReservePatientDialog"
                >
                  <v-icon left small>mdi-account-plus-outline</v-icon>
                  В резерв
                </v-btn>
              </v-card-title>
              <v-card-text class="pa-2">
                <v-list dense>
                  <v-list-item
                    v-for="r in reserveRecords"
                    :key="r.id"
                    class="reserve-item reserve-item-draggable"
                    draggable="true"
                    @dragstart="onReserveDragStart(r)"
                    @dragend="onReserveDragEnd"
                  >
                    <v-list-item-content>
                      <v-list-item-title class="body-2">{{
                        `${r.prenom} ${r.nom}`
                      }}</v-list-item-title>
                      <!-- <v-list-item-subtitle class="caption">{{
                        r.pacientPhone || r.phone
                      }}</v-list-item-subtitle> -->
                      <v-list-item-subtitle v-if="r.doc" class="caption">{{
                        r.doc
                      }}</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-btn
                        small
                        color="primary"
                        text
                        @click="openAssignReserve(r)"
                      >
                        Назначить
                      </v-btn>
                      <v-btn
                        small
                        color="error"
                        text
                        @click="deleteReserveSlot(r.id)"
                      >
                        Отменить
                      </v-btn>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="9">
            <v-sheet height="64">
              <v-toolbar flat>
                <v-toolbar-title v-if="$refs.calendar">
                  {{ $refs.calendar.title }}
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon text @click="closeCalendar">x</v-btn>
              </v-toolbar>
            </v-sheet>
            <v-sheet :height="height - 100">
              <v-calendar
                v-if="focus"
                ref="calendar"
                v-model="focus"
                color="primary"
                :locale-first-day-of-year="1"
                locale="RU"
                :events="events"
                :event-color="getEventColor"
                :event-class="getEventClass"
                :type="type"
                :more="false"
                :first-interval="firstInterval"
                :interval-count="countInterval"
                :interval-minutes="15"
                :short-intervals="false"
                category-show-all
                :categories="categories"
                @click:event="getEvent"
              >
                <template v-slot:[`event`]="{ event }">
                  <p
                    class="text-center d-flex align-center justify-center mb-0 reserve-drop-target"
                    :class="{
                      'reserve-drop-target--active':
                        draggingReserveItem && hoveredDropEvent === event,
                      'reserve-drop-target--dragging': draggingReserveItem,
                    }"
                    @dragover.prevent
                    @dragenter.prevent="onSlotDragEnter(event)"
                    @dragleave.prevent="onSlotDragLeave(event)"
                    @drop.prevent="onReserveDropToSlot(event)"
                  >
                    <template v-if="isBookedEvent(event)">
                      <v-tooltip bottom open-delay="200">
                        <template #activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            v-on="on"
                            small
                            class="mr-1 phone-call-tooltip-activator"
                            :color="getPhoneStatusColor(event)"
                          >
                            {{ getPhoneStatusIcon(event) }}
                          </v-icon>
                        </template>
                        <span>{{ getPhoneStatusTooltip(event) }}</span>
                      </v-tooltip>
                    </template>
                    {{ event.nameRu }}
                  </p>
                  <v-dialog
                    v-model="event.menu"
                    transition="dialog-top-transition"
                    max-width="800"
                  >
                    <v-card class="rounded-xl">
                      <v-toolbar color="grey lighten-1" class="mb-5">
                        <v-toolbar-title class="ma-0">
                          {{ event.name }}
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn icon @click="closeEvent(event)">
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                      </v-toolbar>
                      <v-card-text>
                        <template v-if="!event.isSlot">
                          <v-simple-table>
                            <thead>
                              <tr>
                                <th></th>
                                <th></th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>Врач</td>
                                <td>
                                  <v-chip
                                    @click="
                                      openMedicine(event.medicineNAME, 'table')
                                    "
                                  >
                                    {{ event.medicineNAME }}
                                  </v-chip>
                                </td>
                              </tr>
                              <tr>
                                <td>Специализация</td>
                                <td>{{ event.specialization }}</td>
                              </tr>
                              <tr>
                                <td>Филиал</td>
                                <td>{{ event.branch }}</td>
                              </tr>
                              <tr>
                                <td>Дата и время записи</td>
                                <td>
                                  <v-text-field
                                    type="datetime-local"
                                    v-model="event.start"
                                  ></v-text-field>
                                </td>
                              </tr>
                              <tr>
                                <td>Прозвон</td>
                                <td>
                                  <v-tooltip bottom>
                                    <template #activator="{ on, attrs }">
                                      <v-icon
                                        v-bind="attrs"
                                        v-on="on"
                                        :color="getPhoneStatusColor(event)"
                                        size="32"
                                      >
                                        {{ getPhoneStatusIcon(event) }}
                                      </v-icon>
                                    </template>
                                    <span>{{
                                      getPhoneStatusTooltip(event)
                                    }}</span>
                                  </v-tooltip>
                                </td>
                              </tr>
                              <tr>
                                <td>Время приема</td>
                                <td>
                                  <v-text-field
                                    v-model="event.duree"
                                    type="number"
                                    suffix="мин."
                                  ></v-text-field>
                                </td>
                              </tr>
                              <tr>
                                <td>ФИО пациента</td>
                                <td>
                                  <v-chip @click="openPacient(event, 'event')">
                                    {{ event.pacient }}
                                  </v-chip>
                                </td>
                              </tr>
                              <tr>
                                <td>Планируемая сумма</td>
                                <td>
                                  {{ event.sum }}
                                </td>
                              </tr>
                              <tr>
                                <td>Комментарий</td>
                                <td>
                                  {{ event.comments }}
                                </td>
                              </tr>
                            </tbody>
                          </v-simple-table>
                          <v-row>
                            <v-col cols="6">
                              <v-btn
                                block
                                color="gray"
                                :disabled="loading || isPastEvent(event)"
                                @click="eventCanсel(event)"
                              >
                                Отменить
                              </v-btn>
                            </v-col>
                            <v-col cols="6">
                              <v-btn
                                block
                                color="primary"
                                :disabled="loading || isPastEvent(event)"
                                @click="editEvent(event)"
                              >
                                Изменить
                              </v-btn>
                            </v-col>
                          </v-row>
                        </template>
                        <template v-else>
                          <v-row>
                            <v-col>
                              <v-form>
                                <v-autocomplete
                                  class="mb-2"
                                  v-model="event.assignedID"
                                  :items="allMedicine"
                                  item-text="ФИО"
                                  item-value="Ид"
                                  label="Ответственный"
                                  outlined
                                  hide-details
                                  color="primary"
                                  placeholder="ФИО"
                                  no-data-text="Ничего не найдено"
                                >
                                  <template v-slot:selection="data">
                                    <v-chip
                                      v-bind="data.attrs"
                                      :input-value="data.selected"
                                    >
                                      {{ data.item.ФИО }}
                                    </v-chip>
                                  </template>
                                </v-autocomplete>
                                <v-autocomplete
                                  :items="services"
                                  v-model="event.service"
                                  outlined
                                  item-text="name"
                                  item-value="pl_exam_id"
                                  color="primary"
                                  label="Услуга"
                                  @input="getProductInfo(event)"
                                >
                                </v-autocomplete>
                                <v-textarea
                                  v-model="event.comments"
                                  label="Комментарий"
                                  color="primary"
                                  outlined
                                ></v-textarea>
                                <v-autocomplete
                                  class="mb-2"
                                  v-model="event.pacientID"
                                  :items="pacients"
                                  :search-input.sync="searchPacient"
                                  item-text="name"
                                  item-value="id"
                                  label="Пациент"
                                  outlined
                                  hide-details
                                  color="primary"
                                  clearable
                                  placeholder="ФИО или телефона"
                                  no-data-text="Ничего не найдено"
                                  @update:search-input="onInput"
                                >
                                  <template v-slot:selection="data">
                                    <v-chip
                                      v-bind="data.attrs"
                                      :input-value="data.selected"
                                      @click="openPacient(data.item)"
                                    >
                                      {{ data.item.name }}
                                    </v-chip>
                                  </template>
                                  <template v-slot:item="{ item }">
                                    <div>
                                      <strong>{{ item.name }}</strong>
                                      <div class="text-caption text--secondary">
                                        {{ item.phone }}
                                      </div>
                                      <div class="text-caption text--secondary">
                                        {{ item.birthday }}
                                      </div>
                                    </div>
                                  </template>
                                </v-autocomplete>
                                <template v-if="event.pacientID == 1">
                                  <v-sheet border rounded="xl" class="pa-2">
                                    <v-btn-toggle
                                      v-model="event.male"
                                      mandatory
                                      color="primary"
                                      class="mb-4"
                                    >
                                      <v-btn value="0">Мужчина</v-btn>
                                      <v-btn value="1">Женщина</v-btn>
                                    </v-btn-toggle>
                                    <v-text-field
                                      v-model="event.pacientlastName"
                                      outlined
                                      label="Фамилия пациента"
                                      color="primary"
                                    >
                                    </v-text-field>
                                    <v-text-field
                                      v-model="event.pacientName"
                                      outlined
                                      label="Имя пациента"
                                      color="primary"
                                    >
                                    </v-text-field>
                                    <v-text-field
                                      v-model="event.pacientSecondName"
                                      outlined
                                      label="Отчество пациента"
                                      color="primary"
                                    >
                                    </v-text-field>
                                    <v-menu
                                      ref="birthsdayMenu"
                                      v-model="event.dateMenu"
                                      :close-on-content-click="false"
                                      transition="scale-transition"
                                      offset-y
                                      min-width="auto"
                                    >
                                      <template
                                        v-slot:activator="{ on, attrs }"
                                      >
                                        <v-text-field
                                          v-model="event.pacientBirthsday"
                                          label="Дата рождения"
                                          prepend-inner-icon="mdi-calendar"
                                          readonly
                                          outlined
                                          color="primary"
                                          v-bind="attrs"
                                          v-on="on"
                                        ></v-text-field>
                                      </template>
                                      <v-date-picker
                                        v-model="event.pacientBirthsday"
                                        locale="ru-RU"
                                        :first-day-of-week="1"
                                      >
                                        <v-spacer></v-spacer>
                                        <v-btn
                                          text
                                          color="primary"
                                          @click="event.dateMenu = false"
                                        >
                                          Отмена
                                        </v-btn>
                                        <v-btn
                                          text
                                          color="primary"
                                          @click="
                                            $refs.birthsdayMenu.save(
                                              event.pacientBirthsday,
                                            )
                                          "
                                        >
                                          Сохранить
                                        </v-btn>
                                      </v-date-picker>
                                    </v-menu>
                                    <v-text-field
                                      v-model="event.pacientPhone"
                                      label="Телефон пациента"
                                      type="tel"
                                      outlined
                                      color="primary"
                                    ></v-text-field>
                                    <v-text-field
                                      v-model="event.pacientEmail"
                                      label="Email пациента"
                                      type="email"
                                      outlined
                                      color="primary"
                                    ></v-text-field>
                                    <v-text-field
                                      v-model="event.pacientAddress"
                                      label="Адрес проживания"
                                      outlined
                                      color="primary"
                                    ></v-text-field>
                                  </v-sheet>
                                </template>
                                <v-btn
                                  color="primary"
                                  block
                                  @click="eventAdd(event)"
                                  :disabled="loading"
                                  >Создать запись</v-btn
                                >
                              </v-form>
                            </v-col>
                            <v-col v-if="event.service">
                              <v-row>
                                <v-col cols="auto">
                                  <v-divider vertical></v-divider>
                                </v-col>
                                <v-col>
                                  <v-simple-table>
                                    <thead>
                                      <tr>
                                        <th></th>
                                        <th>Подробнее:</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr>
                                        <td>Дата и время записи</td>
                                        <td>
                                          {{ formatedDateTime(event.start) }}
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>Услуга</td>
                                        <td>{{ event.product }}</td>
                                      </tr>
                                      <tr>
                                        <td>Стоимость</td>
                                        <td>
                                          {{
                                            new Intl.NumberFormat(
                                              "ru-RU",
                                            ).format(event.sum)
                                          }}
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>Время выполнения</td>
                                        <td>{{ event.duree }}</td>
                                      </tr>
                                      <tr>
                                        <td>Подготовка</td>
                                        <td>{{ event.podgotovka }}</td>
                                      </tr>
                                    </tbody>
                                  </v-simple-table>
                                </v-col>
                              </v-row>
                            </v-col>
                          </v-row>
                        </template>
                      </v-card-text>
                    </v-card>
                  </v-dialog>
                </template>
                <template v-slot:category="{ category }">
                  <v-btn
                    text
                    size="x-small"
                    @click="openMedicine(category, 'category')"
                    >{{ category }}</v-btn
                  >
                </template>
              </v-calendar>
            </v-sheet>
          </v-col>
        </v-row>

        <v-dialog v-model="assignReserveDialog" max-width="400" persistent>
          <v-card>
            <v-card-title>Назначить резервного в слот</v-card-title>
            <v-card-text v-if="assignReserveItem">
              <p class="mb-2">
                {{
                  assignReserveItem.pacient ||
                  assignReserveItem.pacientName ||
                  assignReserveItem.patientName
                }}
              </p>
              <v-select
                v-model="assignReserveSlotIndex"
                :items="reserveSlotOptions"
                item-text="text"
                item-value="value"
                label="Выберите слот"
                outlined
                dense
              ></v-select>
              <v-checkbox
                v-model="assignReserveAllowOverwrite"
                class="mt-0"
                hide-details
                label="Разрешить перезапись занятого слота"
              ></v-checkbox>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="assignReserveDialog = false">Отмена</v-btn>
              <v-btn color="primary" text @click="confirmAssignReserveToTime"
                >Назначить</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dropAssignDialog" max-width="460" persistent>
          <v-card>
            <v-card-title>Записать резервного в слот</v-card-title>
            <v-card-text>
              <div v-if="dropAssignReserveItem && dropAssignTargetEvent">
                <div class="mb-2">
                  <strong>{{
                    dropAssignReserveItem.pacient ||
                    dropAssignReserveItem.pacientName ||
                    dropAssignReserveItem.patientName
                  }}</strong>
                </div>
                <div class="mb-2">
                  Слот:
                  {{
                    dropAssignTargetEvent.start
                      ? new Date(dropAssignTargetEvent.start).toLocaleString(
                          "ru-RU",
                        )
                      : `${dropAssignTargetEvent.date || ""} ${
                          dropAssignTargetEvent.time || ""
                        }`.trim()
                  }}
                </div>
                <v-checkbox
                  v-if="dropAssignTargetBusy"
                  v-model="dropAssignAllowOverwrite"
                  class="mt-0"
                  hide-details
                  label="Перезаписать занятую запись"
                ></v-checkbox>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="cancelDropAssign">Отмена</v-btn>
              <v-btn color="primary" text @click="confirmDropAssign"
                >Записать</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="addReservePatientDialog" max-width="560" persistent>
          <v-card v-if="addReservePatientForm">
            <v-card-title>Добавить пациента в резерв</v-card-title>
            <v-card-text>
              <p class="body-2 mb-1">
                <strong>Врач (календарь слева):</strong>
                {{ addReservePatientForm.medicineNAME }}
              </p>
              <p class="body-2 mb-3 text--secondary caption">
                Резерв создаётся для этого врача; список резервов слева тоже
                фильтруется по нему.
              </p>
              <p class="body-2 mb-3">
                <strong>Дата календаря:</strong>
                {{ addReservePatientForm.date }}
              </p>
              <v-autocomplete
                class="mb-3"
                v-model="addReservePatientForm.assignedID"
                :items="allMedicine"
                item-text="ФИО"
                item-value="Ид"
                label="Ответственный"
                outlined
                dense
                hide-details="auto"
                color="primary"
                placeholder="ФИО"
                no-data-text="Ничего не найдено"
              >
                <template v-slot:selection="data">
                  <v-chip
                    v-bind="data.attrs"
                    :input-value="data.selected"
                    small
                  >
                    {{ data.item.ФИО }}
                  </v-chip>
                </template>
              </v-autocomplete>
              <v-autocomplete
                :items="services"
                v-model="addReservePatientForm.service"
                outlined
                dense
                item-text="name"
                item-value="pl_exam_id"
                label="Услуга"
                color="primary"
                hide-details="auto"
                class="mb-3"
                @input="getProductInfo(addReservePatientForm)"
              />
              <v-textarea
                v-model="addReservePatientForm.comments"
                label="Комментарий"
                color="primary"
                outlined
                rows="2"
                hide-details="auto"
                class="mb-2"
              />
              <v-form>
                <v-autocomplete
                  class="mb-2"
                  v-model="addReservePatientForm.pacientID"
                  :items="pacients"
                  :search-input.sync="searchPacient"
                  item-text="name"
                  item-value="id"
                  label="Пациент"
                  outlined
                  hide-details
                  color="primary"
                  clearable
                  placeholder="ФИО или телефон"
                  no-data-text="Ничего не найдено"
                  @update:search-input="onInput"
                >
                  <template v-slot:item="{ item }">
                    <div>
                      <strong>{{ item.name }}</strong>
                      <div class="text-caption text--secondary">
                        {{ item.phone }}
                      </div>
                      <div class="text-caption text--secondary">
                        {{ item.birthday }}
                      </div>
                    </div>
                  </template>
                </v-autocomplete>
                <template v-if="addReservePatientForm.pacientID == 1">
                  <v-sheet border rounded="xl" class="pa-2">
                    <v-btn-toggle
                      v-model="addReservePatientForm.male"
                      mandatory
                      color="primary"
                      class="mb-4"
                    >
                      <v-btn value="0">Мужчина</v-btn>
                      <v-btn value="1">Женщина</v-btn>
                    </v-btn-toggle>
                    <v-text-field
                      v-model="addReservePatientForm.pacientlastName"
                      outlined
                      label="Фамилия пациента"
                      color="primary"
                    />
                    <v-text-field
                      v-model="addReservePatientForm.pacientName"
                      outlined
                      label="Имя пациента"
                      color="primary"
                    />
                    <v-text-field
                      v-model="addReservePatientForm.pacientSecondName"
                      outlined
                      label="Отчество пациента"
                      color="primary"
                    />
                    <v-menu
                      ref="addReserveBirthdayMenu"
                      v-model="addReservePatientForm.dateMenu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="addReservePatientForm.pacientBirthsday"
                          label="Дата рождения"
                          prepend-inner-icon="mdi-calendar"
                          readonly
                          outlined
                          color="primary"
                          v-bind="attrs"
                          v-on="on"
                        />
                      </template>
                      <v-date-picker
                        v-model="addReservePatientForm.pacientBirthsday"
                        locale="ru-RU"
                        :first-day-of-week="1"
                      >
                        <v-spacer></v-spacer>
                        <v-btn
                          text
                          color="primary"
                          @click="addReservePatientForm.dateMenu = false"
                        >
                          Отмена
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="
                            $refs.addReserveBirthdayMenu.save(
                              addReservePatientForm.pacientBirthsday,
                            )
                          "
                        >
                          Сохранить
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                    <v-text-field
                      v-model="addReservePatientForm.pacientPhone"
                      label="Телефон пациента"
                      type="tel"
                      outlined
                      color="primary"
                    />
                    <v-text-field
                      v-model="addReservePatientForm.pacientEmail"
                      label="Email пациента"
                      type="email"
                      outlined
                      color="primary"
                    />
                    <v-text-field
                      v-model="addReservePatientForm.pacientAddress"
                      label="Адрес проживания"
                      outlined
                      color="primary"
                    />
                  </v-sheet>
                </template>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="closeAddReservePatientDialog">Отмена</v-btn>
              <v-btn
                color="primary"
                text
                :disabled="loading"
                @click="submitAddReservePatientToHook"
              >
                В резерв
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-row v-if="!isCalendar">
          <v-col v-if="pacientEvents.length > 0">
            <v-sheet height="64">
              <v-toolbar flat>
                <v-btn
                  outlined
                  class="mr-4"
                  color="grey darken-2"
                  @click="setToday"
                >
                  Сегодня
                </v-btn>
                <v-btn fab text small color="grey darken-2" @click="prev">
                  <v-icon small> mdi-chevron-left </v-icon>
                </v-btn>
                <v-btn fab text small color="grey darken-2" @click="next">
                  <v-icon small> mdi-chevron-right </v-icon>
                </v-btn>
                <v-toolbar-title v-if="$refs.calendar">
                  {{ $refs.calendar.title }}
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon>
                  <v-icon @click="closeViewDay" v-if="typePacient == 'day'"
                    >mdi-close</v-icon
                  >
                </v-btn>
              </v-toolbar>
            </v-sheet>
            <v-sheet height="600">
              <v-calendar
                ref="calendar"
                v-model="focus"
                color="primary"
                :locale-first-day-of-year="1"
                locale="RU"
                :events="pacientEvents"
                :short-intervals="false"
                :more="false"
                :event-color="getEventColor"
                :type="typePacient"
                :first-interval="0"
                :interval-count="144"
                :interval-minutes="10"
                @click:more="viewDay"
                @click:date="viewDay"
                @click:event="getEventPacient"
              >
                <template v-slot:[`event`]="{ event }">
                  <p
                    class="text-center d-flex align-center justify-center mb-0"
                  >
                    <template v-if="isBookedEvent(event)">
                      <v-tooltip bottom open-delay="200">
                        <template #activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            v-on="on"
                            small
                            class="mr-1 phone-call-tooltip-activator"
                            :color="getPhoneStatusColor(event)"
                          >
                            {{ getPhoneStatusIcon(event) }}
                          </v-icon>
                        </template>
                        <span>{{ getPhoneStatusTooltip(event) }}</span>
                      </v-tooltip>
                    </template>
                    {{ event.nameRu }}
                  </p>
                  <v-dialog
                    v-model="event.menu"
                    transition="dialog-top-transition"
                    max-width="600"
                  >
                    <v-card class="rounded-xl">
                      <v-toolbar color="grey lighten-1" class="mb-5">
                        <v-toolbar-title class="ma-0">
                          {{ event.nameRu }}
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn icon @click="closeEventPacient(event)">
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                      </v-toolbar>
                      <v-card-text>
                        <template>
                          <v-simple-table>
                            <thead>
                              <tr>
                                <th></th>
                                <th></th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>Врач</td>
                                <td>
                                  <v-chip
                                    @click="
                                      openMedicine(event.medicineNAME, 'table')
                                    "
                                  >
                                    {{ event.medicineNAME }}
                                  </v-chip>
                                </td>
                              </tr>
                              <tr>
                                <td>Специализация</td>
                                <td>{{ event.specialization }}</td>
                              </tr>
                              <tr>
                                <td>Филиал</td>
                                <td>{{ event.branch }}</td>
                              </tr>
                              <tr>
                                <td>Дата и время записи</td>
                                <td>
                                  <v-text-field
                                    type="datetime-local"
                                    v-model="event.start"
                                  ></v-text-field>
                                </td>
                              </tr>
                              <tr>
                                <td>Прозвон</td>
                                <td>
                                  <v-tooltip bottom>
                                    <template #activator="{ on, attrs }">
                                      <v-icon
                                        v-bind="attrs"
                                        v-on="on"
                                        :color="getPhoneStatusColor(event)"
                                        size="32"
                                      >
                                        {{ getPhoneStatusIcon(event) }}
                                      </v-icon>
                                    </template>
                                    <span>{{
                                      getPhoneStatusTooltip(event)
                                    }}</span>
                                  </v-tooltip>
                                </td>
                              </tr>
                              <tr>
                                <td>Время приема</td>
                                <td>
                                  <v-text-field
                                    v-model="event.duree"
                                    type="number"
                                    suffix="мин."
                                  ></v-text-field>
                                </td>
                              </tr>
                              <tr>
                                <td>ФИО пациента</td>
                                <td>
                                  <v-chip @click="openPacient(event, 'event')">
                                    {{ event.pacient }}
                                  </v-chip>
                                </td>
                              </tr>
                              <tr>
                                <td>Планируемая сумма</td>
                                <td>
                                  {{ event.sum }}
                                </td>
                              </tr>
                              <tr>
                                <td>Комментарий</td>
                                <td>
                                  <v-textarea
                                    v-model="event.comments"
                                    rows="1"
                                    auto-grow
                                  ></v-textarea>
                                </td>
                              </tr>
                            </tbody>
                          </v-simple-table>
                          <v-row>
                            <v-col cols="6">
                              <v-btn
                                block
                                color="gray"
                                :disabled="loading || isPastEvent(event)"
                                @click="eventCanсel(event)"
                              >
                                Отменить
                              </v-btn>
                            </v-col>
                          </v-row>
                        </template>
                      </v-card-text>
                    </v-card>
                  </v-dialog>
                </template>
              </v-calendar>
            </v-sheet>
          </v-col>
          <template v-else>
            <v-simple-table dense class="mt-10 schedule-table">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th
                      rowspan="2"
                      class="header-cell date-column"
                      style="border-top-left-radius: 12px"
                    >
                      Дата
                    </th>
                    <th rowspan="2" class="header-cell doctor-column">Врач</th>
                    <th
                      v-for="(header, headerIndex) in dynamicHeaders"
                      :key="`header-${headerIndex}`"
                      colspan="4"
                      class="text-center filial-header"
                      :style="
                        headerIndex == dynamicHeaders.length - 1
                          ? `border-top-right-radius: 12px;`
                          : ''
                      "
                    >
                      {{ header.LABEL }}
                    </th>
                  </tr>
                  <tr>
                    <template v-for="(header, headerIndex) in dynamicHeaders">
                      <th
                        v-for="(timeSlot, timeIndex) in timeSlots"
                        :key="`subheader-${headerIndex}-${timeIndex}`"
                        class="text-center time-slot-header"
                      >
                        {{ timeSlot }}
                      </th>
                    </template>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="(date, dateIndex) in scheduleTest">
                    <tr
                      v-for="(doctor, doctorIndex) in date.doctors"
                      :key="`row-${dateIndex}-${doctorIndex}`"
                    >
                      <td
                        :style="
                          dateIndex == scheduleTest.length - 1
                            ? `border-bottom-left-radius: 12px;`
                            : ''
                        "
                        v-if="doctorIndex === 0"
                        :rowspan="date.doctors.length"
                        class="date-cell"
                      >
                        {{ date.date }}
                      </td>

                      <td
                        class="doctor-cell"
                        @click="openMedicine(doctor.name, 'category')"
                      >
                        {{ doctor.name }}
                      </td>

                      <template v-for="(filial, filialIndex) in doctor.filials">
                        <td
                          v-for="(time, timeIndex) in filial.times"
                          :key="`data-${filialIndex}-${timeIndex}`"
                          class="text-center data-cell"
                          :class="{
                            'filial-start': timeIndex === 0,
                            'filial-end': timeIndex === filial.times.length - 1,
                          }"
                          :style="
                            dateIndex == scheduleTest.length - 1 &&
                            filialIndex == doctor.filials.length - 1 &&
                            timeIndex == filial.times.length - 1 &&
                            doctorIndex == date.doctors.length - 1
                              ? `border-bottom-right-radius: 12px;`
                              : ''
                          "
                        >
                          <v-btn
                            :class="`${time?.color}`"
                            icon
                            :disabled="time.events.length == 0"
                            text
                            @click="openCalendar(time)"
                          >
                            {{ time.numFree }}
                          </v-btn>
                        </td>
                      </template>
                    </tr>
                  </template>
                  <template v-for="row in schedule">
                    <v-col cols="12" :key="row.title">
                      <p class="mb-0 mt-6">{{ row.title }}</p>
                      <v-simple-table dense class="mt-0">
                        <template v-slot:default>
                          <thead>
                            <tr>
                              <th></th>
                              <th
                                class="text-center"
                                v-for="date in dateHeaders"
                                :key="date"
                              >
                                {{ date }}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="item in row.items"
                              :key="`${row.title}/${item.time}`"
                            >
                              <td class="text-right">{{ item.time }}</td>
                              <td
                                class="text-center"
                                v-for="date in dateHeaders"
                                :key="date"
                              >
                                <v-btn
                                  :class="`${
                                    getObjectByDate(date, item.date)?.color
                                  }`"
                                  icon
                                  :disabled="!getObjectByDate(date, item.date)"
                                  text
                                  @click="
                                    openCalendar(
                                      getObjectByDate(date, item.date),
                                    )
                                  "
                                >
                                  {{
                                    getObjectByDate(date, item.date)
                                      ? getObjectByDate(date, item.date).numFree
                                      : ""
                                  }}
                                </v-btn>
                              </td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </v-col>
                  </template>
                </tbody>
              </template>
            </v-simple-table>
          </template>
        </v-row>
      </v-container>
      <v-container v-else>
        <v-row>
          <v-col style="justify-items: center">
            <h1 style="color: red">У вас нет доступа к календарю!</h1>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import axios from "axios";
import { BX24 } from "bx24";

export default {
  name: "App",
  data: () => ({
    height: "",
    isTrue: false,
    typePacient: "month",
    focus: "",
    intervalId: null,
    medicineItem: {},
    pacientItem: {},
    isCalendar: false,
    timeRefresh: "",
    modal: false,
    timeoutID: null,
    loadingShedule: false,
    loadingSearch: false,
    searchPacient: "",
    pacientID: "",
    pacients: [{ name: "Создать нового", id: 1 }],
    selectedPacient: "",
    menu: false,
    normalDates: [],
    selectModal: "",
    modals: [],
    allModals: [],
    medicines: [],
    selectMedicine: [],
    branch: [],
    eventBranch: [],
    selectBranch: "",
    status: [
      {
        TITLE: "Действующая запись",
        ID: "0",
      },
      {
        TITLE: "Запись удалена",
        ID: "1",
      },
      {
        TITLE: "Запись изменена",
        ID: "2",
      },
      {
        TITLE: "Запись перенесена",
        ID: "3",
      },
    ],
    selectStatus: "",
    newFunc: false,
    loading: false,
    type: "category",
    selectedEvent: {},
    firstInterval: 69,
    countInterval: 13,
    duree: 30,
    events: [],
    categories: [],
    items: [],
    dateHeaders: [],
    headers: [],
    dynamicHeaders: [], // Динамические заголовки филиалов
    timeSlots: ["8-12", "12-15", "15-18", "18-21"],
    scheduleTest: [],
    schedule: [],
    services: [],
    products: [],
    pacientEvents: [],
    today: null,
    allMedicine: [],
    url: "https://msch168.bitrix24.ru/rest/8/2g94jhwiui7vlvbc/",
    userId: null,
    userName: "",
    reserveRecords: [],
    currentCalendarDoctorId: null,
    assignReserveDialog: false,
    assignReserveItem: null,
    assignReserveDate: "",
    assignReserveTime: "",
    assignReserveSlotIndex: null,
    assignReserveAllowOverwrite: false,
    draggingReserveItem: null,
    hoveredDropEvent: null,
    dropAssignDialog: false,
    dropAssignReserveItem: null,
    dropAssignTargetEvent: null,
    dropAssignAllowOverwrite: false,
    medicineLoading: false,
    addReservePatientDialog: false,
    addReservePatientForm: null,
  }),
  computed: {
    sortedBranches() {
      return [...this.branch].sort((a, b) => a.LABEL.localeCompare(b.LABEL));
    },
    filteredReserveRecords() {
      if (!this.currentCalendarDoctorId) return [];
      return this.reserveRecords.filter(
        (item) =>
          String(item.doctorId || item.medicineID || "") ===
          String(this.currentCalendarDoctorId),
      );
    },
    reserveSlotOptions() {
      if (!Array.isArray(this.events)) return [];
      return this.events.map((event, index) => {
        const isBusy = String(event?.busy || "") === "1" || !event?.isSlot;
        const slotType = isBusy ? "Занят" : "Свободен";
        const doctorName = event?.medicineNAME ? `, ${event.medicineNAME}` : "";
        const dateTime = event?.start
          ? new Date(event.start).toLocaleString("ru-RU")
          : `${event?.date || ""} ${event?.time || ""}`.trim();
        return {
          value: index,
          text: `${slotType}: ${dateTime}${doctorName}`,
          isBusy,
        };
      });
    },
    dropAssignTargetBusy() {
      const event = this.dropAssignTargetEvent;
      if (!event) return false;
      return String(event?.busy || "") === "1" || !event?.isSlot;
    },
  },
  methods: {
    getDoctorFilialTimes(doctor, branchId) {
      const filial = doctor.filials.find((f) => f.branchId === branchId);
      return filial ? filial.times : Array(4).fill(null); // 4 - количество временных слотов
    },
    updateDynamicHeaders() {
      try {
        // Формируем заголовки на основе выбранных филиалов
        if (this.selectBranch && this.selectBranch.length > 0) {
          // Если есть выбранные филиалы - показываем только их
          this.dynamicHeaders = this.branch.filter((branch) =>
            this.selectBranch.includes(branch.FM_INTORG_ID),
          );
        } else if (this.eventBranch && this.eventBranch.length > 0) {
          console.log(this.branch);
          console.log(this.eventBranch);
          // Если есть выбранные филиалы - показываем только их
          this.dynamicHeaders = this.branch.filter((branch) =>
            this.eventBranch.includes(branch.FM_INTORG_ID),
          );
        } else {
          // Если нет выбранных филиалов - показываем все
          this.dynamicHeaders = [...this.branch];
        }

        console.log("Dynamic headers updated:", this.dynamicHeaders);
      } catch (error) {
        console.error("Error updating dynamic headers:", error);
      }
    },
    async todayWeek() {
      try {
        this.today = new Date();

        this.dateHeaders = [];

        for (let i = 1; i < 8; i++) {
          let tomorrow = new Date(this.today);
          tomorrow.setDate(tomorrow.getDate() + i);
          this.dateHeaders.push(`${tomorrow.toLocaleDateString("ru-RU")}`);
        }
        this.startPolling();
      } catch (error) {
        console.log({ error });
      }
    },
    async prevWeeks() {
      try {
        let nextWeekStart = new Date(this.today); // Начало следующей недели
        nextWeekStart.setDate(this.today.getDate() - this.today.getDay() - 6); // Понедельник следующей недели

        this.dateHeaders = []; // Массив для хранения дат
        this.today = nextWeekStart;

        for (let i = 0; i < 7; i++) {
          let day = new Date(nextWeekStart);
          day.setDate(nextWeekStart.getDate() + i); // Добавляем дни к понедельнику
          this.dateHeaders.push(`${day.toLocaleDateString("ru-RU")}`); // Форматируем дату
        }
        this.startPolling();
      } catch (error) {
        console.log({ error });
      }
    },
    async nextWeeks() {
      try {
        let nextWeekStart = new Date(this.today); // Начало следующей недели
        nextWeekStart.setDate(
          this.today.getDate() + (7 - this.today.getDay() + 1),
        ); // Понедельник следующей недели
        this.today = nextWeekStart;
        this.dateHeaders = [];

        for (let i = 0; i < 7; i++) {
          let day = new Date(nextWeekStart);
          day.setDate(nextWeekStart.getDate() + i); // Добавляем дни к понедельнику
          this.dateHeaders.push(`${day.toLocaleDateString("ru-RU")}`); // Форматируем дату
        }
        this.startPolling();
      } catch (error) {
        console.log({ error });
      }
    },
    viewDay({ date }) {
      this.focus = date;
      this.typePacient = "day";
    },
    closeViewDay() {
      this.typePacient = "month";
    },
    setToday() {
      this.focus = "";
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    formatDate(date) {
      return new Date(date).toLocaleString();
    },
    onInput(searchPacient) {
      if (this.timeoutId) clearTimeout(this.timeoutId);
      const search = searchPacient || ""; // защита от null
      if (search.length < 3) return;
      this.timeoutId = setTimeout(() => this.getPacient(search), 1500);
    },
    getEventClass(e) {
      return e.event.isOpen == 0 || !e.event.isOpen
        ? ""
        : "non-clickable-event"; // Класс для не кликабельных событий
    },
    getPhoneStatusColor(event) {
      const status = (event?.status || "").toString().toLowerCase();
      if (status === "t") return "green";
      if (status === "nd") return "red";
      return "black";
    },
    getPhoneStatusIcon(event) {
      const status = (event?.status || "").toString().toLowerCase();
      if (status === "t") return "mdi-phone-check";
      if (status === "nd") return "mdi-phone-off";
      return "mdi-phone";
    },
    getPhoneStatusTooltip(event) {
      const status = (event?.status || "").toString().toLowerCase();
      if (status === "t") return "Успешно дозвонились";
      if (status === "nd") return "Не дозвонились";
      return "Статус прозвона не указан";
    },
    isBookedEvent(event) {
      if (!event) return false;
      return String(event.busy || "") === "1" || !!event.pacientID;
    },
    async startPolling() {
      try {
        await this.stopPolling();
        await this.getSchedule();
        this.scheduleNextPoll();
      } catch (error) {
        console.log({ error });
      }
    },
    scheduleNextPoll() {
      this.intervalId = setTimeout(async () => {
        await this.getSchedule();
        if (this.intervalId != null) this.scheduleNextPoll();
      }, 10000);
    },
    forceUpdateHeaders() {
      this.$nextTick(() => {
        this.updateDynamicHeaders();
      });
    },
    async openMedicine(name, type) {
      try {
        let doctor = null;

        if (type == "category") {
          let idx = this.medicines.findIndex((e) => e["shortName"] == name);
          if (idx >= 0) doctor = this.medicines[idx];
          if (!doctor && this.allMedicine && this.allMedicine.length) {
            idx = this.allMedicine.findIndex((e) => e["shortName"] == name);
            if (idx >= 0) doctor = this.allMedicine[idx];
          }
        } else if (type == "table") {
          let idx = this.medicines.findIndex((e) => e["ФИО"] == name);
          if (idx >= 0) doctor = this.medicines[idx];
          if (!doctor && this.allMedicine && this.allMedicine.length) {
            idx = this.allMedicine.findIndex((e) => e["ФИО"] == name);
            if (idx >= 0) doctor = this.allMedicine[idx];
          }
        } else {
          doctor = name;
        }

        if (!doctor) {
          alert("Не удалось найти данные врача для отображения.");
          return;
        }

        this.medicineItem = { ...doctor, modal: true };
        this.medicineLoading = !!doctor["IDB24"];

        if (!this.medicineItem["IDB24"]) {
          this.medicineLoading = false;
          return;
        }

        try {
          const medicineCRM = await axios.post(this.url + "crm.item.get", {
            entityTypeId: 1050,
            id: this.medicineItem["IDB24"],
          });
          if (this.medicineItem.modal) {
            this.medicineItem.speciality =
              medicineCRM.data.result.item.ufCrm12_1734612620557;
            this.medicineItem.specExp =
              medicineCRM.data.result.item.ufCrm12_1734612474;
            this.medicineItem.regalia =
              medicineCRM.data.result.item.ufCrm12_1734612498;
            this.medicineItem.whatCures =
              medicineCRM.data.result.item.ufCrm12_1734612512;
            this.medicineItem.doctorsRating =
              medicineCRM.data.result.item.ufCrm12_1734612526;
            this.medicineItem.ageTake =
              medicineCRM.data.result.item.ufCrm12_1735046188;
            this.medicineItem.experience =
              medicineCRM.data.result.item.ufCrm12_1735046223;
          }
        } catch (err) {
          console.log({ err });
          if (this.medicineItem.modal)
            alert("Ошибка при загрузке информации о враче.");
        } finally {
          this.medicineLoading = false;
        }
      } catch (error) {
        console.log({ error });
        alert("Ошибка при загрузке информации о враче.");
      }
    },
    async openCalendar(item) {
      this.focus = item.dateCalendar;
      this.firstInterval = item.firstInterval;
      this.countInterval = item.countInterval;
      this.currentCalendarDoctorId = item?.events[0]?.medicineID || null;

      // Переносим все записи со статусом "ojidaet_zapis" только в резерв, не добавляя их в this.events (слоты)

      // if (
      //   !item.events.some(
      //     (i) =>
      //       (i.reserve || i.STATUS || i.callStatus || i.status || "") ===
      //       "ojidaet_zapis"
      //   )
      // ) {
      //   item.events.push({
      //     IDB24: "",
      //     assigned: "",
      //     assignedID: null,
      //     branch: "2278",
      //     busy: "0",
      //     callStatus: "",
      //     category: "Сотникова К. Ю.",
      //     color: "grey lighten-1",
      //     comments: "",
      //     date: "",
      //     dateMenu: false,
      //     duree: 30,
      //     end: "",
      //     id: "1471",
      //     isOpen: "0",
      //     isSlot: false,
      //     isWaitingList: false,
      //     medicineID: "2717",
      //     medicineIO: "Сотникова К. Ю.",
      //     medicineNAME: "Сотникова Кристина Юрьевна",
      //     menu: false,
      //     name: "",
      //     nameRu: "Ковалёнок Анастасия Сергеевна",
      //     oldStart: "2026-05-07T10:00:00",
      //     pacient: "Ковалёнок Анастасия Сергеевна",
      //     pacientAddress: "",
      //     pacientBirthsday: "",
      //     pacientCity: "",
      //     pacientEmail: "",
      //     pacientID: "519749",
      //     pacientName: "Анастасия",
      //     pacientPhone: "",
      //     pacientSecondName: "Сергеевна",
      //     pacientlastName: "Ковалёнок",
      //     pl_exam_id: null,
      //     pl_leg: "35",
      //     planningID: "2604055",
      //     plsubjid: "1471",
      //     reserve: "ojidaet_zapis",
      //     service: "",
      //     specialization: "врач-гинеколог(стационар)",
      //     start: "2026-05-07T10:00:00",
      //     status: "t",
      //     sum: "",
      //     time: "10:00",
      //     titleName: "Ковалёнок Анастасия Сергеевна",
      //   });
      // }
      this.events = item.events
        // .filter((i) => {
        //   const status =
        //     i.reserve || i.STATUS || i.callStatus || i.status || "";
        //   if (status === "ojidaet_zapis") {
        //     const reserveId = i.planningID || i.id;
        //     const exists = this.reserveRecords.some(
        //       (r) => (r.planningID || r.id) === reserveId
        //     );
        //     if (!exists)
        //       this.reserveRecords.push({
        //         ...i,
        //         id: reserveId,
        //         planningID: i.planningID || reserveId,
        //       });

        //     return false; // Не добавлять этот слот в this.events
        //   }
        //   return true; // Остальные добавить
        // })
        .map((i) => {
          const status =
            i.reserve || i.STATUS || i.callStatus || i.status || "";
          return {
            ...i,
            status,
            isWaitingList: false,
          };
        });

      this.categories = item.categories;
      this.isCalendar = true;
      await this.getReserveSlots();
      // console.log(item);
    },
    closeCalendar() {
      this.isCalendar = false;
      this.events = [];
      this.currentCalendarDoctorId = null;
    },
    openAssignReserve(reserve) {
      this.assignReserveItem = reserve;
      this.assignReserveDialog = true;
      this.assignReserveSlotIndex = null;
      this.assignReserveAllowOverwrite = false;
      if (this.focus) {
        const d = new Date(this.focus);
        this.assignReserveDate = `${d.getFullYear()}-${String(
          d.getMonth() + 1,
        ).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
      } else {
        const t = new Date();
        this.assignReserveDate = `${t.getFullYear()}-${String(
          t.getMonth() + 1,
        ).padStart(2, "0")}-${String(t.getDate()).padStart(2, "0")}`;
      }
      this.assignReserveTime = reserve.time || reserve.preferredTime || "10:00";
    },
    async cancelReserveRecord(reserve) {
      try {
        if (!reserve) return;
        const reserveId = reserve.planningID || reserve.id;
        if (!reserveId) {
          alert("Не найден id резервной записи.");
          return;
        }
        const approved = window.confirm("Отменить резервную запись?");
        if (!approved) return;

        await axios.get(
          "https://calendar.hospital168.ru/hook/canceledReserv.php",
          {
            params: {
              id: reserveId,
              planning_id: reserveId,
            },
          },
        );

        this.reserveRecords = this.reserveRecords.filter(
          (x) => (x.planningID || x.id) !== reserveId,
        );
        await this.getSchedule();
      } catch (error) {
        console.error("Ошибка отмены резервной записи:", error);
        alert("Не удалось отменить резервную запись.");
      }
    },
    async confirmAssignReserveToTime() {
      if (!this.assignReserveItem) return;
      if (this.assignReserveSlotIndex == null) {
        alert("Выберите слот для назначения.");
        return;
      }
      const targetEvent = this.events[this.assignReserveSlotIndex];
      if (!targetEvent) {
        alert("Слот не найден. Обновите календарь и попробуйте снова.");
        return;
      }
      const isBusy =
        String(targetEvent?.busy || "") === "1" || !targetEvent?.isSlot;
      if (isBusy && !this.assignReserveAllowOverwrite) {
        alert(
          "Слот занят. Включите перезапись занятого слота или выберите свободный.",
        );
        return;
      }

      this.assignReserveDialog = false;
      this.loading = true;
      try {
        await this.setSlot(
          this.assignReserveItem,
          targetEvent,
          this.assignReserveAllowOverwrite,
        );
      } catch (error) {
        console.error(error);
        alert("Ошибка при назначении резерва");
      } finally {
        this.loading = false;
        this.assignReserveItem = null;
        this.assignReserveSlotIndex = null;
        this.assignReserveAllowOverwrite = false;
      }
    },
    onReserveDragStart(reserve) {
      this.draggingReserveItem = reserve;
    },
    onReserveDragEnd() {
      this.draggingReserveItem = null;
      this.hoveredDropEvent = null;
    },
    onSlotDragEnter(event) {
      if (!this.draggingReserveItem) return;
      this.hoveredDropEvent = event;
    },
    onSlotDragLeave(event) {
      if (this.hoveredDropEvent === event) {
        this.hoveredDropEvent = null;
      }
    },
    onReserveDropToSlot(targetEvent) {
      if (!this.draggingReserveItem || !targetEvent) return;
      this.dropAssignReserveItem = this.draggingReserveItem;
      this.dropAssignTargetEvent = targetEvent;
      this.dropAssignAllowOverwrite = false;
      this.dropAssignDialog = true;
      this.draggingReserveItem = null;
      this.hoveredDropEvent = null;
    },
    cancelDropAssign() {
      this.dropAssignDialog = false;
      this.dropAssignReserveItem = null;
      this.dropAssignTargetEvent = null;
      this.dropAssignAllowOverwrite = false;
    },
    async confirmDropAssign() {
      if (!this.dropAssignReserveItem || !this.dropAssignTargetEvent) return;
      if (this.dropAssignTargetBusy && !this.dropAssignAllowOverwrite) {
        alert("Слот занят. Для продолжения включите перезапись.");
        return;
      }

      this.dropAssignDialog = false;
      this.loading = true;
      try {
        await this.setSlot(
          this.dropAssignReserveItem,
          this.dropAssignTargetEvent,
          this.dropAssignAllowOverwrite,
        );
      } catch (error) {
        console.error(error);
        alert("Ошибка при назначении резерва");
      } finally {
        this.loading = false;
        this.dropAssignReserveItem = null;
        this.dropAssignTargetEvent = null;
        this.dropAssignAllowOverwrite = false;
      }
    },
    fillTargetEventFromReserve(targetEvent, reserve) {
      if (!targetEvent || !reserve) return;

      targetEvent.pacientID = reserve.patients_id || reserve.pacientID || "";
      targetEvent.pacientlastName = reserve.nom || "";
      targetEvent.pacientName = reserve.prenom || "";
      targetEvent.pacientSecondName = reserve.patronyme || "";
      targetEvent.pacient =
        [reserve.prenom, reserve.nom].filter(Boolean).join(" ") || "";
      targetEvent.pacientPhone = reserve.pacientPhone || "";
      targetEvent.service = reserve.pl_exam_id || targetEvent.service || "";
      targetEvent.comments = reserve.doc || reserve.comments || "";
      targetEvent.assignedID =
        reserve.assignedid || reserve.assignedID || targetEvent.assignedID;
      targetEvent.pl_exam_id = targetEvent.service; // дубль
      targetEvent.doc = targetEvent.comments; // дубль

      console.log("[fillTargetEventFromReserve] Скопировано:", {
        service: targetEvent.service,
        comments: targetEvent.comments,
        assignedID: targetEvent.assignedID,
        pacient: targetEvent.pacient,
      });
    },
    async setSlot(reserve, event, allowOverwrite = false) {
      try {
        if (!reserve || !event) return false;
        if (String(event?.busy || "") === "1" && !allowOverwrite) {
          alert("Слот занят. Для переноса включите перезапись.");
          return false;
        }
        if (!event.plsubjid) {
          console.error("Нет plsubjid у целевого слота", event);
          alert("Ошибка: слот не содержит идентификатор расписания.");
          return false;
        }

        const targetKey = {
          date: event.date,
          time: event.time,
          plsubjid: event.plsubjid,
          medicineID: event.medicineID,
        };

        // 1. Отменяем старую запись и обновляем расписание
        await this.eventCanсel(event, "cancel", {
          skipCloseCalendar: true,
          skipCloseEvent: true,
          skipRefresh: false,
        });

        // 2. Удаляем резервную запись
        await this.deleteReserveSlot(reserve.id, true);

        // 3. Ждём 1 секунду – даём серверу время на снятие блокировок
        await new Promise((resolve) => setTimeout(resolve, 1000));

        // 4. Находим актуальный слот в обновлённом расписании
        const freshEvent = this.events.find(
          (e) =>
            e.date === targetKey.date &&
            e.time === targetKey.time &&
            e.plsubjid === targetKey.plsubjid &&
            e.medicineID === targetKey.medicineID,
        );
        if (!freshEvent) {
          console.error("Слот не найден после обновления", targetKey);
          alert("Ошибка: слот не найден. Попробуйте ещё раз.");
          return false;
        }

        // 5. Копируем данные из резерва в актуальный слот
        this.fillTargetEventFromReserve(freshEvent, reserve);

        // 6. Создаём новую запись (без лишних обновлений)
        const newPlanningId = await this.eventAdd(freshEvent, "add", {
          keepCalendarOpen: true,
          skipOverlapCheck: true,
          skipRefresh: true,
        });

        if (!newPlanningId) {
          alert("Не удалось записать резервного в слот.");
          return false;
        }

        // 7. Финальное обновление календаря и резервов
        await this.getSchedule();
        await this.getReserveSlots();

        // 8. НЕ открываем диалог автоматически
        return true;
      } catch (error) {
        console.error("Ошибка в setSlot:", error);
        alert("Ошибка при назначении резерва. Попробуйте еще раз.");
        return false;
      }
    },
    applyReserveToEvent(event) {
      if (!event.reserveId) return;
      const r = this.reserveRecords.find((x) => x.id === event.reserveId);
      if (r) {
        event.pacient = r.pacient || r.pacientName || r.patientName || "";
        event.pacientID = r.pacientID || r.id;
        event.comments =
          (event.comments || "") +
          (r.comments || r.comment
            ? ` [Резерв: ${r.comments || r.comment}]`
            : "");
      }
    },
    applyReserveToSlot(event) {
      if (!event.reserveId) return;
      const r = this.reserveRecords.find((x) => x.id === event.reserveId);
      if (r) {
        const fullName = r.pacient || r.pacientName || r.patientName || "";
        event.pacientID = r.pacientID || r.id;
        event.pacientlastName = fullName.split(" ")[0] || "";
        event.pacientName = fullName.split(" ")[1] || "";
        event.pacientSecondName = fullName.split(" ")[2] || "";
        event.pacientPhone = r.pacientPhone || r.phone || "";
        event.comments =
          (event.comments || "") +
          (r.comments || r.comment
            ? ` [Резерв: ${r.comments || r.comment}]`
            : "");
      }
    },
    resetEventOnClose(event) {
      if (!event) return;
      event.reserveId = null;
      event.assignedID = "";
      event.service = "";
      event.comments = "";
      event.pacientID = null;
      event.pacient = "";
      event.pacientName = "";
      event.pacientlastName = "";
      event.pacientSecondName = "";
      event.pacientPhone = "";
      event.pacientEmail = "";
      event.pacientAddress = "";
      event.pacientBirthsday = "";
      event.sum = "";
      event.product = "";
      event.podgotovka = "";
    },
    async openPacient(item, type = "pacient") {
      if (type == "event") {
        // console.log({ item });
        const response = await axios.get(
          "https://calendar.hospital168.ru/hook/getPacients.php",
          {
            params: { search: item.pacient },
          },
        );
        // console.log({ response });
        this.pacientItem = {
          name: `${response.data.pacients[0].NOM} ${response.data.pacients[0].PRENOM} ${response.data.pacients[0].PATRONYME}`,
          id: response.data.pacients[0].PATIENTS_ID,
          birthday: response.data.pacients[0].NE_LE.split(" ")[0],
          phone: response.data.pacients[0].MOBIL_TELEFON,
          email: response.data.pacients[0].E_MAIL,
          male: response.data.pacients[0].POL == 1 ? "Муж" : "Жен",
          modal: false,
          emailAgent: response.data.pacients[0]["email представителя"],
          city: response.data.pacients[0]["Город по прописке"],
          addres: response.data.pacients[0]["адрес фактический"],
          nameAgent: `${response.data.pacients[0]["фамилия представителя"]} ${response.data.pacients[0]["имя представителя"]} ${response.data.pacients[0]["отчество представителя"]}`,
          phoneAgent: response.data.pacients[0]["телефон представителя"],
        };
        this.pacientItem.modal = true;
      } else {
        this.pacientItem = item;
        this.pacientItem.modal = true;
      }
    },
    remove(item, type) {
      if (type == "medicine") {
        const index = this.selectMedicine.indexOf(item["Ид"]);
        if (index >= 0) this.selectMedicine.splice(index, 1);
      } else if (type == "pacient") {
        this.selectedPacient = "";
      } else {
        const index = this.selectModal.indexOf(item.title);
        if (index >= 0) this.selectModal.splice(index, 1);
      }
    },
    async getPacient(searchPacient) {
      try {
        this.pacients = [{ name: "Создать нового", id: 1 }];
        // console.log(searchPacient);
        const response = await axios.get(
          "https://calendar.hospital168.ru/hook/getPacients.php",
          {
            params: { search: searchPacient },
          },
        );
        // console.log({ response });
        for (const pacient of response.data.pacients) {
          this.pacients.push({
            name: `${pacient.NOM} ${pacient.PRENOM} ${pacient.PATRONYME}`,
            id: pacient.PATIENTS_ID,
            birthday: pacient.NE_LE.split(" ")[0],
            phone: pacient.MOBIL_TELEFON,
            email: pacient.E_MAIL,
            male: pacient.POL == 1 ? "Муж" : "Жен",
            modal: false,
            emailAgent: pacient["email представителя"],
            city: pacient["Город по прописке"],
            addres: pacient["адрес фактический"],
            nameAgent: `${pacient["фамилия представителя"]} ${pacient["имя представителя"]} ${pacient["отчество представителя"]}`,
            phoneAgent: pacient["телефон представителя"],
          });
        }
      } catch (error) {
        console.error("Ошибка при загрузке данных:", error);
        this.pacients = [];
      }
    },
    async getMedicine() {
      try {
        this.medicineIds = [];
        let isTrue = false;
        let elementID = 0;
        while (!isTrue) {
          const medicines = await axios.post(this.url + "crm.item.list", {
            entityTypeId: 1050,
            filter: {
              ">id": elementID,
            },
            select: ["*"],
            start: -1,
          });
          //   console.log(medicines.data.result.items);
          if (medicines.data.result.items.length > 0) {
            for (const medicine of medicines.data.result.items) {
              elementID = medicine.id;
              this.medicines.push({
                id: medicine.id,
                medicineId: medicine.ufCrm12_1734612598371,
                title: medicine.title,
                modal: false,
                speciality: medicine.ufCrm12_1734612620557,
                specExp: medicine.ufCrm12_1734612474,
                regalia: medicine.ufCrm12_1734612498,
                whatCures: medicine.ufCrm12_1734612512,
                doctorsRating: medicine.ufCrm12_1734612526,
                ageTake: medicine.ufCrm12_1735046188,
                experience: medicine.ufCrm12_1735046223,
              });
            }
            // console.log(this.medicines);
          } else {
            isTrue = true;
          }
        }
      } catch (error) {
        console.log({ error });
      }
    },
    async getServices(medicineID) {
      try {
        // console.log({ medicineID });
        this.services = [];
        const services = await axios.get(
          "https://calendar.hospital168.ru/hook/getServiceType.php",
          {
            params: {
              id: medicineID,
            },
          },
        );

        console.log(services.data.services);
        const servicesData = [];
        for (const service of services.data.services) {
          servicesData.push({
            name: `${service.name} (${service.duree})`,
            duree: service.duree,
            MEDECINS_ID: service.MEDECINS_ID,
            PL_SUBJ_ID: service.PL_SUBJ_ID,
            code: service.code,
            fm_serv_id: service.fm_serv_id,
            pl_exam_id: service.pl_exam_id,
          });
        }
        this.services = servicesData;
        console.log(this.services);
      } catch (error) {
        console.log({ error });
      }
    },
    async getMedicinesToModals() {
      try {
        this.loading = true;
        this.medicines = [];
        if (this.selectModal) {
          const modals = this.modals.filter(
            (e) => e.title == this.selectModal,
          )[0];
          for (const modalIndex in modals.modals) {
            const plparamid = modals.modals[modalIndex];
            const getMedicineIDs = await axios.get(
              "https://calendar.hospital168.ru/hook/getMedicineIDs.php",
              {
                params: {
                  plparamid,
                },
              },
            );

            for (const medicine of getMedicineIDs.data.medicineIDs) {
              const index = this.medicines.findIndex(
                (e) => e["Ид"] == medicine["Ид"],
              );
              if (index < 0) {
                this.medicines.push(medicine);
              }
            }
          }
        }

        this.medicines = this.medicines.filter((doctor) => doctor["ФИО"]);
        this.medicines.sort((a, b) => a["ФИО"].localeCompare(b["ФИО"]));
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async getModals() {
      try {
        const response = await axios.get(
          "https://calendar.hospital168.ru/hook/getModal.php",
        );
        this.allModals = response.data.modals; // Сохраняем в кэш
        this.filterModalsByBranch(); // Применяем текущую фильтрацию
      } catch (error) {
        console.log({ error });
      }
    },
    formatDateToKey(date) {
      const [day, month, year] = date.split(".");
      return `${year}-${month}-${day}`;
    },
    getObjectByDate(date, objects) {
      const dateKey = this.formatDateToKey(date);
      return objects[dateKey];
    },
    formatTime(time) {
      const timeString = String(time).padStart(4, "0"); // Добавляем ведущие нули, если нужно (830 -> 0830)
      return `${timeString.slice(0, 2)}:${timeString.slice(2)}`; // Разделяем на часы и минуты
    },
    async getSchedule() {
      try {
        this.eventBranch = [];
        this.loadingShedule = true;

        let openPacientEventId = null;
        if (
          this.selectedPacient &&
          Array.isArray(this.pacientEvents) &&
          this.pacientEvents.length
        ) {
          const opened = this.pacientEvents.find((e) => e && e.menu);
          if (opened) openPacientEventId = opened.id;
        }
        if (this.selectedPacient) {
          this.schedule = [];
          const response = await axios.get(
            "https://calendar.hospital168.ru/hook/getShedulePacients.php",
            {
              params: { id: this.selectedPacient },
            },
          );
          console.log(response.data, "response.data");
          const pacientEvents = [];
          for (const item of response.data.plannings) {
            const pacient = this.pacients.filter(
              (e) => e.id == this.selectedPacient,
            )[0];

            const medicine = this.allMedicine
              ? this.allMedicine.find((m) => m.Ид == item.MEDECINS_ID)
              : this.medicines.find((m) => m.Ид == item.MEDECINS_ID);
            const date = item.DATE_CONS.split(" ")[0]; // Получаем дату без времени
            const formattedTime = this.formatTime(item.HEURE); // Преобразуем время в формат "HH:MM"
            const start = `${date}T${formattedTime}:00`;
            // console.log({ start });
            const dateTime = new Date(start);
            //  console.log({ dateTime });
            //  console.log(item.DUREE);
            dateTime.setMinutes(dateTime.getMinutes() + parseInt(item.DUREE));
            //   console.log({ dateTime });
            const end = dateTime.toISOString().slice(0, 19).replace("T", " ");
            //   console.log({ end });
            console.log(pacient, medicine);

            const event = {
              start,
              end,
              color: "green",
              nameRu: item.NAME,
              id: item.PLANNING_ID,
              menu: false,
              dateMenu: false,
              duree: item.DUREE,
              titleName: item.NAME,
              medicine: "", //medicine.name,
              medicineID: item.MEDECINS_ID,
              medicineNAME: medicine ? medicine.ФИО : "",
              robotCallStatus: false,
              branch: item["филиал"],
              status: item.STATUS,
              isWaitingList:
                (item.reserve || item.STATUS || item.callStatus || "") ===
                "ojidaet_zapis",
              pacientID: item.PATIENTS_ID,
              pacient: pacient.name,
              pacientPhone: pacient.phone,
              assignedID: item["Пользователь создавший запись"],
              assigned: "", //assigned.name,
              comments: item.COMMENTAIRE,
              sum: item["сумма оплаты"]
                ? item["сумма оплаты"]
                : item["Планируемая сумма"],
              planningID: item.PLANNING_ID,
              service: item.NAME,
            };
            pacientEvents.push(event);
          }
          this.pacientEvents = pacientEvents;

          if (openPacientEventId) {
            const reopened = this.pacientEvents.find(
              (e) => e.id === openPacientEventId,
            );
            if (reopened) reopened.menu = true;
          }
        } else {
          this.pacientEvents = [];
          // const scheduleArr = [];
          if (this.selectModal) {
            const modals = this.modals.filter(
              (e) => e.title == this.selectModal,
            )[0];
            const plsubjs = [];
            const medecinsid = this.selectMedicine;
            console.log("medecinsid (для getGuideSchedule):", medecinsid);

            for (const modalIndex in modals.modals) {
              console.log({ modalIndex });
              const indexBranch = this.eventBranch.indexOf(modalIndex);
              if (indexBranch == -1) {
                this.eventBranch.push(modalIndex);
              }

              // console.log(this.selectBranch);
              if (this.selectBranch.length > 0) {
                const isTrue = this.selectBranch.indexOf(modalIndex);
                // console.log({ isTrue });

                if (isTrue > -1) {
                  const plparamid = modals.modals[modalIndex];
                  console.log("params для getGuideSchedule:", {
                    plparamid,
                    medecinsid,
                  });
                  const guideSchedule = await axios.get(
                    "https://calendar.hospital168.ru/hook/getGuideSchedule.php",
                    {
                      params: {
                        plparamid,
                        medecinsid,
                      },
                    },
                  );
                  console.log({ guideSchedule });
                  for (const item of guideSchedule.data.guideSchedule) {
                    plsubjs.push({
                      branch: modalIndex,
                      plsubjid: item.PL_SUBJ_ID,
                      start: this.dateHeaders[0],
                      end: this.dateHeaders[this.dateHeaders.length - 1],
                    });
                  }
                }
              } else {
                const plparamid = modals.modals[modalIndex];
                console.log("params для getGuideSchedule:", {
                  plparamid,
                  medecinsid,
                });
                const guideSchedule = await axios.get(
                  "https://calendar.hospital168.ru/hook/getGuideSchedule.php",
                  {
                    params: {
                      plparamid,
                      medecinsid,
                    },
                  },
                );
                console.log({ guideSchedule });
                for (const item of guideSchedule.data.guideSchedule) {
                  plsubjs.push({
                    branch: modalIndex,
                    plsubjid: item.PL_SUBJ_ID,
                    start: this.dateHeaders[0],
                    end: this.dateHeaders[this.dateHeaders.length - 1],
                  });
                }
              }
            }
            console.log("plsubjid (для getShedule):", plsubjs);
            const schedules = await axios.get(
              "https://calendar.hospital168.ru/hook/getShedule.php",
              {
                params: {
                  plsubjid: plsubjs,
                  status: this.selectStatus,
                },
              },
            );
            console.log({ schedules });

            this.scheduleTest = schedules.data;

            this.schedule = (schedules.data.schedule || []).map((row) => {
              const nextRow = { ...row };
              if (Array.isArray(nextRow.events)) {
                nextRow.events = nextRow.events.map((event) => ({
                  ...event,
                  status: event.reserve || event.STATUS || event.status || "",
                  isWaitingList:
                    (event.reserve || event.status || event.STATUS || "") ===
                    "ojidaet_zapis",
                }));
              }
              return nextRow;
            });
            console.log(this.schedule, "schedule");
            this.updateDynamicHeaders();

            const now = new Date();
            const hours = now.getHours().toString().padStart(2, "0"); // Добавляем ведущий ноль, если нужно
            const minutes = now.getMinutes().toString().padStart(2, "0"); // Добавляем ведущий ноль, если нужно
            const seconds = now.getSeconds().toString().padStart(2, "0"); // Добавляем ведущий ноль, если нужно
            this.timeRefresh = `${hours}:${minutes}:${seconds}`;
          } else {
            alert("Вы не выбрали специализацию!");
            await this.stopPolling();
          }
        }
        this.loadingShedule = false;
      } catch (error) {
        console.log({ error });
      }
    },
    getEventPacient(e) {
      e.event.menu = !e.event.menu;
    },
    closeEventPacient(e) {
      e.menu = !e.menu;
    },
    async eventCanсel(e, type = "cancel", options = {}) {
      try {
        if (type == "cancel") this.loading = true;
        const res = await axios.get(
          "https://calendar.hospital168.ru/hook/canceledEvent.php",
          {
            params: { planning_id: e.planningID },
          },
        );
        console.log(res, "Результат отмены события");
        if (e.menu !== undefined && !options.skipCloseEvent) e.menu = !e.menu;
        if (!options.skipRefresh) await this.getSchedule();
        if (e.isOpen !== undefined && !options.skipCloseEvent)
          await this.closeEvent(e);
        if (!options.skipCloseCalendar) this.closeCalendar();
        if (type == "cancel") this.loading = false;
      } catch (error) {
        console.log({ error });
      }
    },

    async checkSlotLock(planningId) {
      try {
        if (!planningId || !this.userId) {
          return { locked: false };
        }
        const response = await axios.get(
          "https://calendar.hospital168.ru/hook/checkLock.php",
          {
            params: {
              planning_id: planningId,
              user_id: this.userId,
            },
          },
        );
        return response.data || { locked: false };
      } catch (error) {
        console.error("Ошибка при проверке блокировки слота:", error);
        return { locked: false };
      }
    },

    async lockSlot(planningId) {
      try {
        if (!planningId || !this.userId || !this.userName) {
          return false;
        }
        const response = await axios.get(
          "https://calendar.hospital168.ru/hook/lockSlot.php",
          {
            params: {
              planning_id: planningId,
              user_id: this.userId,
              user_name: this.userName,
            },
          },
        );
        return response.data && response.data.success !== false;
      } catch (error) {
        console.error("Ошибка при блокировке слота:", error);
        return false;
      }
    },

    async unlockSlot(planningId) {
      try {
        if (!planningId || !this.userId) {
          return false;
        }
        const response = await axios.get(
          "https://calendar.hospital168.ru/hook/unlockSlot.php",
          {
            params: {
              planning_id: planningId,
              user_id: this.userId,
            },
          },
        );
        return response.data && response.data.success !== false;
      } catch (error) {
        console.error("Ошибка при разблокировке слота:", error);
        return false;
      }
    },
    logSlotOpenData(event, source = "unknown") {
      if (!event) return;
      const debugPayload = {
        source,
        id: event.id,
        planningID: event.planningID,
        busy: event.busy,
        date: event.date,
        time: event.time,
        STATUS: event.STATUS,
        callStatus: event.callStatus,
        status: event.status,
        reserve: event.reserve,
        medicineID: event.medicineID,
        medicineNAME: event.medicineNAME,
        pacientID: event.pacientID,
        pacient: event.pacient,
        pacientPhone: event.pacientPhone,
        branch: event.branch,
        comments: event.comments,
      };
      console.groupCollapsed(
        `[slot-open] ${source} | id=${event.id || "no-id"} | planningID=${
          event.planningID || "no-planningID"
        }`,
      );
      console.log("slot summary:", debugPayload);
      console.log("slot full object:", { ...event });
      console.groupEnd();
    },
    async getEvent(e) {
      this.logSlotOpenData(e?.event, "getEvent:before-open");
      if (e.event.busy == "1") {
        const planning = await axios.get(
          "https://spa-bitrix.ru/webhooks/msch-168/getID.php",
          {
            params: {
              method: "getPlannigId",
              id: e.event.planningID,
            },
          },
        );
        if (
          planning.data &&
          Array.isArray(planning.data) &&
          planning.data.length > 0
        ) {
          e.event.name = planning.data[0].NAME || "";
          e.event.comments = planning.data[0].COMMENTAIRE || "";
          e.event.assignedID =
            planning.data[0]["Пользователь создавший запись"] || "";
          e.event.sum =
            planning.data[0]["Планируемая сумма"].split(".")[0] || "";
          e.event.service = planning.data[0]["PL_EXAM_ID"] || "";
          e.event.assignedID =
            planning.data[0]["Пользователь создавший запись"] || "";
        }
        e.event.newEnd = "";
      } else {
        const planningId = e.event.planningID || e.event.id;

        if (planningId && this.userId) {
          const lockInfo = await this.checkSlotLock(planningId);
          console.log(lockInfo);
          if (
            lockInfo &&
            lockInfo.locked &&
            lockInfo.user_id &&
            lockInfo.user_id != this.userId
          ) {
            const lockedBy = lockInfo.user_name || "другим оператором";
            return alert(
              `Запись недоступна, так как с расписанием работает ${lockedBy}. Пожалуйста, попробуйте позже.`,
            );
          }
          await this.getProducts(e.event.medicineID, e.event.branch);
          e.event.isOpen = 1;
          // console.log(e);
          const date = new Date(e.event.date); // Указанная дата
          const startOfYear = new Date(date.getFullYear(), 0, 1); // Начало года (1 января)
          // Вычисляем разницу в миллисекундах
          const diffInMilliseconds = date - startOfYear;
          // Преобразуем разницу в дни
          const diffInDays = Math.floor(
            diffInMilliseconds / (1000 * 60 * 60 * 24),
          );

          const openEvent = await axios.get(
            "https://calendar.hospital168.ru/hook/reserve.php",
            {
              params: {
                id: `${e.event.id};${diffInDays};${
                  e.event.time.split(":")[0]
                };${e.event.time.split(":")[1]};${e.event.medicineID}`,
                value: 1,
              },
            },
          );
          console.log(openEvent); // Вывод: 71
          await this.lockSlot(planningId);
        }
      }

      // if (e.event.busy == "1") {

      // } else {

      // }
      e.event.menu = !e.event.menu;
      e.event.robotCallStatus = false;
    },
    async closeEvent(e) {
      //console.log({ e });
      this.resetEventOnClose(e);
      e.menu = !e.menu;
      e.isOpen = 0;
      const date = new Date(e.date); // Указанная дата
      const startOfYear = new Date(date.getFullYear(), 0, 1); // Начало года (1 января)
      // Вычисляем разницу в миллисекундах
      const diffInMilliseconds = date - startOfYear;
      // Преобразуем разницу в дни
      const diffInDays = Math.floor(diffInMilliseconds / (1000 * 60 * 60 * 24));
      console.log(diffInDays); // Вывод: 71
      const closeEvent = await axios.get(
        "https://calendar.hospital168.ru/hook/reserve.php",
        {
          params: {
            id: `${e.id};${diffInDays};${e.time.split(":")[0]};${
              e.time.split(":")[1]
            };${e.medicineID}`,
            value: 0,
          },
        },
      );
      console.log(closeEvent);

      // Снимаем блокировку слота в БД
      const planningId = e.planningID || e.id;
      if (planningId) {
        await this.unlockSlot(planningId);
      }
    },
    getEventColor(event) {
      // console.log({ event });
      if (event.isOpen == 1) {
        return "orange";
      }
      return event.color;
    },
    stopPolling() {
      if (this.intervalId != null) {
        clearTimeout(this.intervalId);
        this.intervalId = null;
      }
      return Promise.resolve();
    },
    addMinutes(date, minutes) {
      return new Date(date.getTime() + minutes * 60000);
    },
    hasOpenDialog() {
      try {
        if (this.medicineItem && this.medicineItem.modal) return true;
        if (this.pacientItem && this.pacientItem.modal) return true;
        if (this.assignReserveDialog) return true;
        if (this.addReservePatientDialog) return true;
        if (Array.isArray(this.events)) {
          if (this.events.some((e) => e && e.menu)) return true;
        }
        if (Array.isArray(this.pacientEvents)) {
          if (this.pacientEvents.some((e) => e && e.menu)) return true;
        }

        return false;
      } catch (e) {
        console.log({ e });
        return false;
      }
    },
    isPastEvent(event) {
      try {
        if (!event || !event.start) return false;
        const eventDate = new Date(event.start);
        const now = new Date();
        return eventDate < now;
      } catch (e) {
        console.log({ e });
        return false;
      }
    },
    getProductInfo(event) {
      //получаем инфо по виду услуги(кабинет, время выполнения)
      const service = this.services.filter(
        (e) => e.pl_exam_id == event.service,
      )[0];
      console.log({ service });
      event.duree = service.duree; //+
      /*const products = this.products.filter(
            (e) => e.FM_SERV_ID == service.fm_serv_id
          )[0];*/
      //console.log({ products });

      event.sum = service.sum;
      event.podgotovka = service.podgotovka;
      event.product = service.name;
      console.log(event.start);
      console.log(event.duree);

      let oldDate = new Date(event.start);
      let newDate = this.addMinutes(oldDate, event.duree);

      const year = newDate.getFullYear();
      const month = String(newDate.getMonth() + 1).padStart(2, "0"); // Месяцы начинаются с 0
      const day = String(newDate.getDate()).padStart(2, "0");
      const hours = String(newDate.getHours()).padStart(2, "0");
      const minutes = String(newDate.getMinutes()).padStart(2, "0");
      const seconds = String(newDate.getSeconds()).padStart(2, "0");

      event.end = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
      console.log(event.end); // Вывод: "2025-03-13T16:50:00"
      /*const date = new Date(event.start + "Z");
          const minutesTo = date.getMinutes() + event.duree.padStart(2, "0");
          console.log(minutesTo);
          date.setMinutes(minutesTo);

          // Форматируем дату вручную, чтобы избежать перевода в UTC
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, "0"); // Месяцы начинаются с 0
          const day = String(date.getDate()).padStart(2, "0");
          const hours = String(date.getHours()).padStart(2, "0");
          const minutes = String(date.getMinutes()).padStart(2, "0");
          const seconds = String(date.getSeconds()).padStart(2, "0");

          event.end = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
          console.log(event.end); // Вывод: "2025-03-13T16:50:00"
          console.log({ event });*/
      console.log({ event });
    },
    isOverlapping(event1, event2, type = "add") {
      console.log({ type });
      console.log({ event1 });
      console.log({ event2 });

      const start1 = new Date(
        type == "add" ? event1.start : event1.oldStart,
      ).getTime();
      const end1 = new Date(event1.end).getTime();
      const start2 = new Date(event2.start).getTime();
      const end2 = new Date(
        type == "add" ? event2.end : event2.newEnd,
      ).getTime();

      return start1 < end2 && end1 > start2;
    },
    buildEventAddParamEvent(event, pacientID, type = "add") {
      const dateStart = new Date(event.start);

      const day = String(dateStart.getDate()).padStart(2, "0");
      const month = String(dateStart.getMonth() + 1).padStart(2, "0");
      const year = dateStart.getFullYear();

      const hours = String(dateStart.getHours()).padStart(2, "0");
      const minutes = String(dateStart.getMinutes()).padStart(2, "0");
      const seconds = String(dateStart.getSeconds()).padStart(2, "0");

      const formattedDate = `${day}.${month}.${year}`;
      const formattedDateTimeStart = `${day}.${month}.${year} ${hours}:${minutes}:${seconds}`;
      const dateEnd = new Date(type == "add" ? event.end : event.newEnd);

      const hoursEnd = String(dateEnd.getHours()).padStart(2, "0");
      const minutesEnd = String(dateEnd.getMinutes()).padStart(2, "0");
      const secondsEnd = String(dateEnd.getSeconds()).padStart(2, "0");
      const time =
        type == "add"
          ? event.time
          : event.start.split("T")[1].split(":")[0] +
            event.start.split("T")[1].split(":")[1];
      const formattedDateTimeEnd = `${day}.${month}.${year} ${hoursEnd}:${minutesEnd}:${secondsEnd}`;

      return {
        pl_subj_id: event.plsubjid,
        date: formattedDate,
        heure: time.replace(/[^\w\s]|_/g, ""),
        duree: event.duree,
        patients_id: pacientID,
        nom: event.pacientlastName,
        prenom: event.pacientName,
        patronyme: event.pacientSecondName,
        pl_exam_id: event.service,
        date_start: formattedDateTimeStart,
        date_end: formattedDateTimeEnd,
        doc: event.comments,
        assignedID: event.assignedID,
      };
    },
    parsePlanningIdFromHookResponse(data) {
      if (data == null || data === "") return null;
      if (typeof data === "number" && !Number.isNaN(data)) return String(data);
      if (typeof data === "string") {
        const s = data.trim();
        if (!s) return null;
        if (/^\d+$/.test(s)) return s;
        try {
          const parsed = JSON.parse(s);
          return this.parsePlanningIdFromHookResponse(parsed);
        } catch (_) {
          return null;
        }
      }
      if (Array.isArray(data)) {
        if (!data.length) return null;
        return this.parsePlanningIdFromHookResponse(data[0]);
      }
      if (typeof data === "object") {
        const keys = [
          "planning_id",
          "planningID",
          "PLANNING_ID",
          "id",
          "ID",
          "result",
          "planningId",
        ];
        for (let i = 0; i < keys.length; i++) {
          const k = keys[i];
          if (data[k] != null && data[k] !== "") return String(data[k]);
        }
        if (data.data != null)
          return this.parsePlanningIdFromHookResponse(data.data);
      }
      return null;
    },
    // appendReserveRecordToSidebarAfterReservedAdd(event, pacientID, planningId) {
    //   const pid =
    //     planningId && String(planningId).trim() !== ""
    //       ? String(planningId).trim()
    //       : `client-reserve-${Date.now()}`;
    //   if (
    //     this.reserveRecords.some(
    //       (r) => String(r.planningID || r.id) === String(pid)
    //     )
    //   ) {
    //     return;
    //   }
    //   const fullName = [
    //     event.pacientlastName,
    //     event.pacientName,
    //     event.pacientSecondName,
    //   ]
    //     .filter((x) => x && String(x).trim())
    //     .join(" ")
    //     .trim();
    //   const docId =
    //     event.medicineID ||
    //     this.currentCalendarDoctorId ||
    //     event.doctorId ||
    //     "";
    //   this.reserveRecords.push({
    //     id: pid,
    //     planningID: pid,
    //     doctorId: docId,
    //     medicineID: docId,
    //     pacientID,
    //     pacient: fullName,
    //     pacientName: fullName,
    //     patientName: fullName,
    //     pacientPhone: event.pacientPhone || "",
    //     phone: event.pacientPhone || "",
    //     comments: event.comments || "",
    //     comment: event.comments || "",
    //     medicineNAME: event.medicineNAME || "",
    //     nameRu: fullName,
    //     titleName: fullName,
    //     reserve: "ojidaet_zapis",
    //     STATUS: "ojidaet_zapis",
    //     status: "ojidaet_zapis",
    //     time: event.time || "00:00",
    //     preferredTime: event.time || "00:00",
    //     branch: event.branch,
    //     plsubjid: event.plsubjid,
    //     start: event.start,
    //   });
    // },
    closeAddReservePatientDialog() {
      this.addReservePatientDialog = false;
      this.addReservePatientForm = null;
    },
    async openAddReservePatientDialog() {
      if (!this.isCalendar) {
        alert("Откройте календарь врача.");
        return;
      }
      const doctorId = this.currentCalendarDoctorId;
      if (!doctorId) {
        alert(
          "Не определён врач открытого календаря. Откройте расписание врача из таблицы ещё раз.",
        );
        return;
      }
      if (!this.focus) {
        alert("Выберите дату в календаре.");
        return;
      }
      if (!Array.isArray(this.events) || !this.events.length) {
        alert(
          "Нет данных расписания. Откройте день врача из таблицы или обновите страницу.",
        );
        return;
      }
      const ref = this.events.find(
        (e) =>
          e && e.plsubjid && String(e.medicineID || "") === String(doctorId),
      );
      if (!ref || !ref.plsubjid) {
        alert(
          "Не удалось найти расписание (plsubjid) для выбранного врача в этом календаре.",
        );
        return;
      }
      const dateKey =
        typeof this.focus === "string" && this.focus.includes("T")
          ? this.focus.split("T")[0]
          : this.focus;
      const time = "00:00";
      const start = `${dateKey}T00:00:00`;
      const duree = 30;
      const endDate = this.addMinutes(new Date(start), duree);
      const ey = endDate.getFullYear();
      const em = String(endDate.getMonth() + 1).padStart(2, "0");
      const ed = String(endDate.getDate()).padStart(2, "0");
      const eh = String(endDate.getHours()).padStart(2, "0");
      const eim = String(endDate.getMinutes()).padStart(2, "0");
      const es = String(endDate.getSeconds()).padStart(2, "0");
      const end = `${ey}-${em}-${ed}T${eh}:${eim}:${es}`;

      this.addReservePatientForm = {
        plsubjid: ref.plsubjid,
        branch: ref.branch,
        medicineID: ref.medicineID,
        medicineNAME: ref.medicineNAME || ref.category || "",
        date: dateKey,
        time,
        start,
        end,
        duree,
        comments: "",
        assignedID:
          ref.assignedID != null && ref.assignedID !== ""
            ? ref.assignedID
            : ref.medicineID || null,
        service: ref.service || "",
        pacientID: null,
        menu: false,
        dateMenu: false,
        male: "0",
        pacientlastName: "",
        pacientName: "",
        pacientSecondName: "",
        pacientBirthsday: "",
        pacientPhone: "",
        pacientEmail: "",
        pacientAddress: "",
      };

      await this.getProducts(ref.medicineID, ref.branch);
      if (!this.addReservePatientForm) return;
      if (!this.services.length) {
        alert("Нет доступных услуг для этого врача и филиала.");
        this.addReservePatientForm = null;
        return;
      }
      this.addReservePatientForm.service = this.services[0].pl_exam_id;
      this.getProductInfo(this.addReservePatientForm);
      this.addReservePatientDialog = true;
    },
    async submitAddReservePatientToHook() {
      const event = this.addReservePatientForm;
      if (!event) return;
      if (!event.pacientID) {
        alert("Выберите пациента.");
        return;
      }
      if (!event.service) {
        alert("Выберите услугу.");
        return;
      }
      try {
        await this.eventAdd(event, "add", { reserveAdd: true });
        this.closeAddReservePatientDialog();
      } catch (error) {
        console.error(error);
        alert("Не удалось добавить пациента в резерв. Проверьте данные.");
      }
    },
    async getReserveSlots() {
      try {
        const plSubjId =
          this.events.length > 0 ? this.events[0].plsubjid : null;
        const date = this.focus ? this.focus.split("T")[0] : null;

        if (!plSubjId || !date) {
          console.warn("Нет pl_subj_id или даты для запроса резервов");
          this.reserveRecords = [];
          return;
        }

        const response = await axios.get(
          "https://calendar.hospital168.ru/hook/getReserved.php",
          {
            params: {
              pl_subj_id: plSubjId,
              date: date,
            },
          },
        );
        console.log(response, "Ответ от получения резервных");
        const reservedList = response.data || [];

        this.reserveRecords = reservedList;
      } catch (error) {
        console.error("Ошибка получения резервных слотов:", error);
        this.reserveRecords = [];
      }
    },
    async deleteReserveSlot(id, skipRefresh = false) {
      try {
        const response = await axios.get(
          "https://calendar.hospital168.ru/hook/delReserved.php",
          { params: { id } },
        );
        if (response.status == 200) {
          this.reserveRecords = this.reserveRecords.filter(
            (item) => String(item.id) !== String(id),
          );
          if (!skipRefresh) await this.getSchedule();
          if (this.assignReserveDialog) {
            this.assignReserveDialog = false;
            this.assignReserveItem = null;
          }
        } else {
          alert("Не удалось удалить резервную запись.");
        }
      } catch (error) {
        console.error("Ошибка удаления резерва:", error);
        alert("Ошибка при удалении резервной записи.");
      }
    },
    async eventAdd(event, type = "add", options = {}) {
      const reserveAdd =
        Boolean(options && options.reserveAdd === true) && type === "add";
      const skipOverlapCheck = options.skipOverlapCheck === true;
      const skipRefresh = options.skipRefresh === true;
      if (type == "add") this.loading = true;
      try {
        if (!reserveAdd && !skipOverlapCheck) {
          const isBusy = this.events.some(
            (e) => e.busy === "1" && this.isOverlapping(e, event, type),
          );
          console.log({ isBusy });
          if (isBusy) {
            alert(
              "Выбранная услуга не помещается в расписание врача на этот день! выберите другое время для записи!",
            );
            return;
          }
        }

        let pacientID = event.pacientID;
        if (type == "add") {
          if (event.pacientID == 1) {
            const date = new Date(event.pacientBirthsday);

            const day = String(date.getDate()).padStart(2, "0"); // Получаем день и добавляем ведущий ноль, если нужно
            const month = String(date.getMonth() + 1).padStart(2, "0"); // Получаем месяц (начинается с 0, поэтому +1) и добавляем ведущий ноль
            const year = date.getFullYear(); // Получаем год

            const formattedDate = `${day}.${month}.${year}`;
            const paramsClient = {
              email: event.pacientEmail,
              name: event.pacientName,
              surname: event.pacientlastName,
              patronymic: event.pacientSecondName,
              birthday: formattedDate,
              telephone: event.pacientPhone,
              address: event.pacientAddress,
              male: event.male,
            };
            const pacient = await axios.get(
              "https://calendar.hospital168.ru/hook/pacientAdd.php",
              {
                params: paramsClient,
              },
            );
            console.log({ pacient });
            console.log({ paramsClient });

            pacientID = pacient.data[0];
          } else {
            const pacient = this.pacients.filter(
              (e) => e.id == event.pacientID,
            )[0];
            if (!pacient) {
              alert("Пациент не найден в списке.");
              return;
            }
            console.log({ pacient });
            event.pacientAddress = pacient.addres;
            event.pacientBirthsday = pacient.birthday;
            event.pacientEmail = pacient.email;
            event.pacientPhone = pacient.phone;
            event.pacientName = pacient.name.split(" ")[1];
            event.pacientSecondName = pacient.name.split(" ")[2];
            event.pacientlastName = pacient.name.split(" ")[0];
          }
        }
        const dateStart = new Date(event.start);

        const day = String(dateStart.getDate()).padStart(2, "0");
        const month = String(dateStart.getMonth() + 1).padStart(2, "0");
        const year = dateStart.getFullYear();

        const hours = String(dateStart.getHours()).padStart(2, "0");
        const minutes = String(dateStart.getMinutes()).padStart(2, "0");
        const seconds = String(dateStart.getSeconds()).padStart(2, "0");

        const formattedDate = `${day}.${month}.${year}`;
        const formattedDateTimeStart = `${day}.${month}.${year} ${hours}:${minutes}:${seconds}`;
        const dateEnd = new Date(type == "add" ? event.end : event.newEnd);

        const hoursEnd = String(dateEnd.getHours()).padStart(2, "0");
        const minutesEnd = String(dateEnd.getMinutes()).padStart(2, "0");
        const secondsEnd = String(dateEnd.getSeconds()).padStart(2, "0");
        const time =
          type == "add"
            ? event.time
            : event.start.split("T")[1].split(":")[0] +
              event.start.split("T")[1].split(":")[1];
        const formattedDateTimeEnd = `${day}.${month}.${year} ${hoursEnd}:${minutesEnd}:${secondsEnd}`;
        let paramEvent = {};
        console.log(event.assignedID, "aassignedId");
        reserveAdd
          ? (paramEvent = {
              pl_subj_id: event.plsubjid,
              date: formattedDate,

              patients_id: pacientID,
              nom: event.pacientlastName,
              prenom: event.pacientName,
              patronyme: event.pacientSecondName,
              pl_exam_id: event.service,

              doc: event.comments,
              assignedID: event.assignedID,
              // cabinet: cabinet,
            })
          : (paramEvent = {
              pl_subj_id: event.plsubjid,
              date: formattedDate,
              heure: time.replace(/[^\w\s]|_/g, ""),
              duree: event.duree,
              patients_id: pacientID,
              nom: event.pacientlastName,
              prenom: event.pacientName,
              patronyme: event.pacientSecondName,
              pl_exam_id: event.service,
              date_start: formattedDateTimeStart,
              date_end: formattedDateTimeEnd,
              doc: event.comments,
              assignedID: event.assignedID,
              // cabinet: cabinet,
            });
        const addHookUrl = reserveAdd
          ? "https://calendar.hospital168.ru/hook/addReserved.php"
          : "https://calendar.hospital168.ru/hook/eventAdd.php";
        if (reserveAdd) {
          let eventSnapshot;
          try {
            eventSnapshot = JSON.parse(JSON.stringify(event));
          } catch {
            eventSnapshot = { ...event };
          }
          console.log("[резервный слот] данные перед отправкой", {
            url: addHookUrl,
            params: { ...paramEvent },
            pacientID,
            options: { ...options },
            event: eventSnapshot,
          });
        }
        const res = await axios.get(addHookUrl, {
          params: paramEvent,
        });
        console.log(res, "Ответ при создании слота");
        if (!skipRefresh) await this.getSchedule();
        if (reserveAdd) {
          if (!skipRefresh) await this.getReserveSlots();
        } else {
          if (!options.keepCalendarOpen) {
            await this.closeEvent(event);
            this.closeCalendar();
          } else {
            event.menu = false;
            event.isOpen = 0;
            const planningId = event.planningID || event.id;
            if (planningId) await this.unlockSlot(planningId);
          }
        }

        return 1;
      } finally {
        if (type == "add") this.loading = false;
      }
    },
    async editEvent(event) {
      try {
        console.log(event);
        this.loading = true;
        let oldDate = new Date(event.start);
        let newDate = this.addMinutes(oldDate, event.duree);

        const year = newDate.getFullYear();
        const month = String(newDate.getMonth() + 1).padStart(2, "0"); // Месяцы начинаются с 0
        const day = String(newDate.getDate()).padStart(2, "0");
        const hours = String(newDate.getHours()).padStart(2, "0");
        const minutes = String(newDate.getMinutes()).padStart(2, "0");
        const seconds = String(newDate.getSeconds()).padStart(2, "0");

        event.newEnd = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
        console.log(event.end); // Вывод: "2025-03-13T16:50:00"

        const res = await this.eventAdd(event, "edit");
        if (res == 1) {
          this.eventCanсel(event, "edit");
        }
        this.loading = false;
      } catch (error) {
        console.log({ error });
      }
    },
    async getAllMedicine() {
      try {
        const medicines = await axios.get(
          "https://calendar.hospital168.ru/hook/getAllMedicine.php",
        );
        // console.log({ medicines });
        this.allMedicine = medicines.data.medicines;
      } catch (error) {
        // console.log({ error });
      }
    },
    async getProducts(medecins, orgtype) {
      try {
        this.services = [];
        const services = await axios.get(
          "https://calendar.hospital168.ru/hook/getProducts.php",
          {
            params: { medecins, orgtype },
          },
        );
        const servicesData = [];
        for (const service of services.data.products) {
          servicesData.push({
            name: `${service.LABEL} (${service.DUREE})`,
            duree: service.DUREE,
            MEDECINS_ID: medecins,
            podgotovka: service.podgotovka,
            sum: service.Cost,
            fm_serv_id: orgtype,
            pl_exam_id: service.PL_EXAM_ID,
          });
        }
        this.services = servicesData;
        console.log(this.services, "products");
      } catch (error) {
        console.log({ error });
      }
    },
    formatedDateTime(dateTime) {
      const date = new Date(dateTime); // Создаем объект Date

      // Форматируем дату
      const day = String(date.getDate()).padStart(2, "0"); // День (с ведущим нулем)
      const month = String(date.getMonth() + 1).padStart(2, "0"); // Месяц (с ведущим нулем)
      const year = date.getFullYear(); // Год
      const hours = String(date.getHours()).padStart(2, "0"); // Часы (с ведущим нулем)
      const minutes = String(date.getMinutes()).padStart(2, "0"); // Минуты (с ведущим нулем)
      const seconds = String(date.getSeconds()).padStart(2, "0"); // Секунды (с ведущим нулем)

      return `${day}.${month}.${year} ${hours}:${minutes}:${seconds}`;
    },
    async getBranch() {
      try {
        this.branch = [];
        /* const branch = await axios.get(
              "https://calendar.hospital168.ru/hook/getBranch.php"
            );
            console.log({ branch });*/
        this.branch = [
          { LABEL: "Арбузова 1/1", FM_INTORG_ID: "2278", CODE: "Арбузова 1/1" },
          { LABEL: "Коптюга 13", FM_INTORG_ID: "2300", CODE: "Коптюга 13" },
          { LABEL: "ВАСХНИЛ", FM_INTORG_ID: "2525", CODE: "ВАСХНИЛ" },
          { LABEL: "Новая заря", FM_INTORG_ID: "3155", CODE: "Новая заря" },
        ]; //branch.data;
        console.log(this.branch);
      } catch (error) {
        console.log({ error });
      }
    },
    async filterModalsByBranch(selectedBranches = null) {
      const branches = selectedBranches || this.selectBranch;

      // Если нет выбранных филиалов - показываем все
      if (!branches || branches.length === 0) {
        this.modals = [...this.allModals].sort((a, b) =>
          a.title.localeCompare(b.title),
        );
        return;
      }

      // Фильтруем из кэша
      const filteredModals = this.allModals.filter((modal) => {
        const modalBranchIds = Object.keys(modal.modals);
        return branches.some((selectedBranchId) =>
          modalBranchIds.includes(selectedBranchId.toString()),
        );
      });

      this.modals = filteredModals.sort((a, b) =>
        a.title.localeCompare(b.title),
      );

      // Сбрасываем выбранную специализацию если она не доступна
      if (
        this.selectModal &&
        !this.modals.some((modal) => modal.title === this.selectModal)
      ) {
        this.selectModal = "";
        this.medicines = [];
      }
    },
  },
  watch: {
    selectBranch: {
      handler(newVal) {
        this.filterModalsByBranch(newVal);
        this.updateDynamicHeaders(); // Обновляем заголовки при изменении выбора филиалов
      },
      deep: true,
      immediate: false,
    },
    branch: {
      handler() {
        this.updateDynamicHeaders(); // Обновляем при изменении списка филиалов
      },
      deep: true,
      immediate: true,
    },
    scheduleTest: {
      handler() {
        this.$nextTick(() => {
          this.updateDynamicHeaders();
        });
      },
      deep: true,
      immediate: false,
    },
  },
  async mounted() {
    const bx24 = new BX24();
    this.auth = await bx24.getAuth();
    const url = `https://${this.auth.DOMAIN}/rest/`;
    const user = await axios.post(url + "profile", {
      auth: this.auth.ACCESS_TOKEN,
    });
    console.log({ user });
    if (
      user.data.result.ADMIN ||
      user.data.result.ID == 250 ||
      user.data.result.ID == 430
    ) {
      this.isTrue = true;
    }

    this.userId = 2;
    this.userName = "operator 2";
    this.height = window.innerHeight;
    this.isTrue = true;
    console.log(this.isTrue);
    this.loading = true;
    this.today = new Date();
    this.dateHeaders.push(`${this.today.toLocaleDateString("ru-RU")}`);
    for (let i = 1; i < 30; i++) {
      let tomorrow = new Date(this.today);
      tomorrow.setDate(tomorrow.getDate() + i);
      this.dateHeaders.push(`${tomorrow.toLocaleDateString("ru-RU")}`);
    }

    await this.getAllMedicine();
    await this.getModals();
    await this.getBranch();

    this.loading = false;
  },
};
</script>
<style>
/* Основные стили таблицы */
.schedule-table {
  border-collapse: collapse;
  width: 100%;
  table-layout: fixed;
}

/* Общие стили ячеек */
.schedule-table th,
.schedule-table td {
  padding: 6px 4px;
  text-align: center;
}

/* Заголовки */
.header-cell {
  background-color: #e0e0e0;
  font-weight: bold;
  border: 1px solid #000 !important;
}

.filial-header {
  background-color: #bdbdbd;
  border: 1px solid #000 !important;
  font-weight: bold;
}

.time-slot-header {
  background-color: #eeeeee;
  border: 1px solid #000 !important;
  font-weight: 500;
}

/* Колонки */
.date-column {
  width: 100px;
}

.doctor-column {
  width: 180px;
}

/* Тело таблицы */
.date-cell {
  font-weight: bold;
  background-color: #f5f5f5;
  border: 1px solid #000 !important;
  vertical-align: middle;
}

.doctor-cell {
  border: 1px solid #000 !important;
  text-align: left;
  padding-left: 12px !important;
}

.data-cell {
  border-top: 1px solid #000 !important;
  border-bottom: 1px solid #000 !important;
  min-width: 50px;
}

/* Выделение зон филиалов */
.filial-start {
  border-left: 1px solid #000 !important;
}

.filial-end {
  border-right: 1px solid #000 !important;
}

/* Вертикальные разделители между филиалами */
tr td:not(.filial-start) {
  border-left: none !important;
}

tr td:not(.filial-end) {
  border-right: none !important;
}

.v-calendar-category__column-header {
  display: flex;
  justify-content: center;
}

.non-clickable-event {
  pointer-events: none;
  opacity: 0.5;
}

.non-clickable-event .phone-call-tooltip-activator {
  pointer-events: auto;
}

.reserve-sidebar {
  border-right: 1px solid rgba(0, 0, 0, 0.12);
  background: #fafafa;
}

.reserve-sidebar .reserve-item {
  min-height: 48px;
}

.reserve-item-draggable {
  cursor: grab;
}

.reserve-item-draggable:active {
  cursor: grabbing;
}

.reserve-drop-target {
  display: block;
  width: 100%;
  min-height: 100%;
  padding: 2px 4px;
  border-radius: 6px;
  transition: background-color 0.15s ease;
}

.reserve-drop-target--active {
  background-color: rgba(33, 150, 243, 0.18);
}

.reserve-drop-target--dragging {
  cursor: copy;
}
</style>
